// #region Page load

const _surveyLink = getSurveyLink();

let _workflowUniqueKey;

let _builder, _builderHidden, _globalForm;
let _formSchema;
let _startTime;

let _surveyTitle, _surveyId, _attemptId;

let _languageContainer = {},
  _isMultiLanguage = false,
  _languageNames = [
    { label: "English", tag: "en", htmlLang: "en", dir: "ltr" },
    { label: "Arabic", tag: "ar", htmlLang: "ar", dir: "rtl" },
    { label: "Hindi", tag: "hi", htmlLang: "hi", dir: "ltr" },
    { label: "Urdu", tag: "ur", htmlLang: "ur", dir: "rtl" },
  ],
  _defaultLanguage = { label: "English", tag: "en" },
  _userLanguage;

let _surveyImages,
  _fileData = [],
  _submissionLogos = [];

let _audioCtx,
  _canvasCtx,
  _recorderMainSection,
  _recorderCanvas,
  _recordingBlob,
  _recordingClipLabel,
  _recordingData = [];

let _fileUploadData = [];

let _customCss = [];

let _submissionMessage = "Thank you for taking the survey.";

let _surveyValidation = [],
  _uniquenessValidatedComponents = [],
  _requiredValidationErrors = [];

let _linkedQuestions = [];

let _alias = [];

let _linkedData = [],
  _linkedSurveyData = [],
  _multidataLinkedDetails = [],
  _multidataLinkedCurrent = {};

let _linkedPictures = [];

let _otpDetails = [];

let _formSubmissionMessageDetails = [],
  _duplicateSubmissionMessage = {},
  _formSubmissionMessageAnswers = [];

let _questionList = [];

let _pageBackground = {};

let _certificate = {},
  _enablePrinting = false;

let _noneOfAboveDetails = [];

let _locationInfo = {},
  _isLocationAccessGranted = false,
  _locationFetched = false,
  _locationAccessReqComplete = false,
  _locationAccuracy;

let _timerInfo = {};

let _workflowDetails = {};

let _categoryLimit = [],
  _categoryLimitErrors = [],
  _categoryLimitExceeded = [];

let _advancedValidationSurveyData = [],
  _advancedValidationSurveyAnswerList = [];

let _editGridComponentChangedCount = 0;

let _optionContact = [],
  _isEmailOptionEnabled = false;

let _hiddenCount = 0,
  _totalPages = 1,
  _currentPage = 0;

let _currentQuestionKey,
  _currentFormChange = 0,
  _prevFormChange = 0;

let _surveyAttempt = {};

let _draftData = [];

let _shuffleId = Date.now();

let _uniqueQuestions = [],
  _uniqueQuestionsValidationResults = [];

let _userAnswers = [],
  _token = "",
  _saveAnswersInterval,
  _submissionStatus = "NotStarted";

let _enablePageNavigation = false;

let _questionGroups = [],
  _questionGroupsRendered = [],
  _isQuestionGroupRendered = false;

const _defaultFormTranslation = {
  ar: {
    Submit: "التسليم",
    Cancel: "حذف",
    Save: "حفظ",
    "Add Another": "إضافة آخر",
  },
  hi: {
    Submit: "सबमिट",
    Cancel: "रद्द",
    Save: "सहेजें",
    "Add Another": "एक अन्य जोड़ें",
  },
  ur: {
    Submit: "جمع کرائیں",
    Cancel: "منسوخ کریں",
    Save: "محفوظ کریں",
    "Add Another": "ایک دیگر اضافہ",
  },
};

let _translationData = {
  en: {
    timeLeft: "Time left",
    recordNameLabel: "Enter a name for your sound clip?",
    recordName: "My unnamed clip",
    recordAudio: "Record audio",
    record: "Record",
    stop: "Stop",
    delete: "Delete",
    save: "Save",
    close: "Close",
    cancel: "Cancel",
    load: "Load",
    generateOtp: "Generate OTP",
    otpValidFor: "OTP valid for",
    submitOtp: "Submit OTP",
    otpExpired: "Your OTP has expired. Please try again after some time.",
    otpMobileNum: "Please enter the mobile number",
    enterOtp: "Please enter the OTP",
    otpVerified: "OTP verified successfully",
    otpIncorrect: "Incorrect OTP",
    duplicateSubmission:
      "You filled this survey before! You are not allowed to fill this survey more than once.",
    duplicateRanking: "Duplicate ranking found in multi-choice questions!",
    invalidRanking: "Invalid ranking found in multi-choice questions!",
    userName: "User name",
    password: "Password",
    next: "Next",
    previous: "Previous",
    surveyStatus: "Survey status",
    print: "Print",
    saveDraft: "Save draft",
    loadDraft: "Load draft",
    surveyStatus: "Survey status",
    draftSubmission: "Draft submission",
    userName: "User name",
    password: "Password",
    validUserName: "Please provide a valid user name.",
    validPassword: "Please provide a valid password.",
    workflowStatus: "Workflow status",
    workflowUniqueKey: "Workflow unique key",
    forgotUniqueKey: "Forgot unique key?",
    resendUniqueKey: "Resend unique key",
    validWorkflowUniqueKey: "Please provide the workflow unique key.",
    search: "Search",
    allowLocationAccess: "Please allow location access to take the survey.",
    submittedDetails: "Your data has been successfully submitted!",
    uniqueKeyIs: "Your unique key is {UNIQUEKEY}",
    savingDraft: "Saving draft...",
    savedDraft: "Successfully saved draft.",
    loadingDraft: "Loading draft...",
    back: "Back",
    enterNameSoundClip: "Enter a new name for your sound clip?",
    enterOtpHere: "Enter otp here",
    progress: "Progress",
    fileSizeError: "Total file size should not exceed 60 MB",
    accepted: "Accepted",
    rejected: "Rejected",
    inprogress: "In progress",
    loggingIn: "Logging in...",
    loginFailed: "User id or password is incorrect.",
    loadingSavedData: "Loading saved data...",
    alreaySubmitted: "You have already submitted this survey.",
  },
  ar: {
    timeLeft: "الوقت المتبقي",
    recordNameLabel: "ادخل اسم لتسجيلك الصوتي",
    recordName: "مقطع تسجيل بلا اسم",
    recordAudio: "تسجيل صوتي",
    record: "سجِلّ",
    stop: "إيقاف",
    delete: "إلغاء",
    save: "حفظ",
    close: "إغلاق",
    cancel: "إغلاق",
    load: "تحميل",
    generateOtp: "إنشاء رمز التحقق",
    otpValidFor: "OTP صالح لـ",
    submitOtp: "تسليم رمز التحقق",
    otpExpired: "انتهت صلاحية رمز التحقق. الرجاء المحاولة مرة أخرى.",
    otpMobileNum: "الرجاء إدخال رقم الهاتف المحمول",
    enterOtp: "الرجاء إدخال كلمة المرور لمرة واحدة",
    otpVerified: "رمز التحقق صحيح",
    otpIncorrect: "رمز التحقق غير صحيح.",
    duplicateSubmission:
      "لقد ملأت الاستبيان من قبل! لا يسمح لك بملء هذا الاستبيان أكثر من مرة.",
    duplicateRanking: "تم العثور على ترتيب مكرر في أسئلة الاختيار من متعدد!",
    invalidRanking: "تم العثور على طلب غير صالح في أسئلة الاختيار من متعدد",
    userName: "اسم المستخدم",
    password: "كلمة المرور",
    next: "التالي",
    previous: "السابق",
    surveyStatus: "حالة الاستطلاع",
    print: "طباعة",
    saveDraft: "حفظ المسودة",
    loadDraft: "تحميل المسودة",
    surveyStatus: "حالة الاستطلاع",
    draftSubmission: "تسليم المسودة",
    userName: "اسم المستخدم",
    password: "كلمة المرور",
    validUserName: "الرجاء توفير اسم المستخدم.",
    validPassword: "الرجاء توفير كلمة المرور",
    workflowStatus: "حالة نظام التتبع",
    workflowUniqueKey: "المفتاح الأساسي لنظام التتبع",
    forgotUniqueKey: "هل نسيت المفتاح الأساسي لنظام التتبع؟",
    resendUniqueKey: "إعادة إرسال المفتاح الأساسي لنظام التتبع",
    validWorkflowUniqueKey: "الرجاء توفير المفتاح الأساسي لنظام التتبع",
    search: "البحث",
    allowLocationAccess: "يرجى السماح بالوصول إلى الموقع لإجراء الاستطلاع.",
    submittedDetails: "لقد تم إرسال بياناتكم بنجاح!",
    uniqueKeyIs: "المفتاحك الرئيسي هو {UNIQUEKEY}",
    savingDraft: "جارٍ حفظ المسودة...",
    savedDraft: "تم حفظ المسودة بنجاح.",
    loadingDraft: "جارٍ تحميل المسودة...",
    back: "الخلفي",
    enterNameSoundClip: "أدخل اسمًا جديدًا لمقطع الصوت الخاص بك؟",
    enterOtpHere: "أدخل كلمة المرور لمرة واحدة هنا",
    progress: "التقدم",
    fileSizeError: "يجب ألا يتجاوز حجم الملف الإجمالي 60 ميجا بايت",
    accepted: "مقبول",
    rejected: "مرفوض",
    inprogress: "قيد التنفيذ",
    loggingIn: "جاري تسجيل الدخول...",
    loginFailed: "معرف المستخدم أو كلمة المرور غير صحيحة.",
    loadingSavedData: "جاري تحميل البيانات المحفوظة...",
    alreaySubmitted: "لقد قمت بإرسال هذا الاستطلاع من قبل.",
  },
  hi: {
    timeLeft: "शेष समय",
    recordNameLabel: "अपनी ध्वनि क्लिप के लिए एक नाम दर्ज करें",
    recordName: "मेरी अनाम क्लिप",
    recordAudio: "ऑडियो रिकॉर्ड करें",
    record: "रिकॉर्ड",
    stop: "रुको",
    delete: "मिटाना",
    save: "सहेजें",
    close: "बंद",
    cancel: "रद्द",
    load: "लोड",
    generateOtp: "OTP जनरेट करें",
    otpValidFor: "OTP वैध",
    submitOtp: "OTP सबमिट करें",
    otpExpired:
      "OTP ओटीपी समाप्त हो गया है। कृपया कुछ समय बाद पुन: प्रयास करें।",
    otpMobileNum: "मोबाइल नंबर दर्ज करें",
    enterOtp: "कृपया OTP दर्ज करें",
    otpVerified: "OTP सफलतापूर्वक सत्यापित किया गया",
    otpIncorrect: "गलत OTP",
    duplicateSubmission:
      "आपने यह सर्वेक्षण पहले भरा था! आपको इस सर्वेक्षण को एक से अधिक बार भरने की अनुमति नहीं है।",
    duplicateRanking: "बहुविकल्पीय प्रश्नों में डुप्लीकेट रैंकिंग मिली!",
    invalidRanking: "बहुविकल्पीय प्रश्नों में मिला अमान्य क्रम",
    userName: "उपयोगकर्ता नाम",
    password: "पासवर्ड",
    next: "अगला",
    previous: "पिछला",
    surveyStatus: "सर्वेक्षण स्थिति",
    print: "फ़ोटो",
    saveDraft: "ड्राफ़्ट सहेजें",
    loadDraft: "ड्राफ्ट लोड करें",
    surveyStatus: "सर्वेक्षण की स्थिति",
    draftSubmission: "ड्राफ्ट सबमिशन",
    userName: "उपयोगकर्ता नाम",
    password: "पासवर्ड",
    validUserName: "कृपया कोई मान्य उपयोगकर्ता नाम प्रदान करें.",
    validPassword: "कृपया एक मान्य पासवर्ड प्रदान करें.",
    workflowStatus: "कृपया कोई मान्य पासवर्ड प्रदान करें.",
    workflowUniqueKey: "कार्यप्रवाह कुंजी",
    validWorkflowUniqueKey: "कृपया वर्कफ़्लो कुंजी प्रदान करें.",
    search: "तलाश",
    allowLocationAccess:
      "कृपया सर्वेक्षण करने के लिए स्थान एक्सेस की अनुमति दें.",
    submittedDetails: "आपका डेटा सफलतापूर्वक सबमिट कर दिया गया है!",
    uniqueKeyIs: "आपकी कुंजी है {UNIQUEKEY}",
    savingDraft: "ड्राफ़्ट सहेजना...",
    savedDraft: "सफलतापूर्वक सहेजा गया ड्राफ़्ट.",
    loadingDraft: "ड्राफ्ट लोड हो रहा है...",
    back: "पीछे",
    enterNameSoundClip: "अपनी ध्वनि क्लिप के लिए कोई नया नाम दर्ज करें?",
    enterOtpHere: "यहां ओटीपी दर्ज करें",
    progress: "प्रगति",
    fileSizeError: "कुल फ़ाइल आकार 60 MB से अधिक नहीं होना चाहिए",
    accepted: "स्वीकृत",
    rejected: "अस्वीकृत",
    inprogress: "प्रगति पर है",
    loggingIn: "Logging in...",
    loginFailed: "User id or password is incorrect.",
    loadingSavedData: "Loading saved data...",
    alreaySubmitted: "You have already submitted this survey.",
  },
  ur: {
    timeLeft: "وقت رہ گیا۔",
    recordNameLabel: "اپنے ساؤنڈ کلپ کے لیے ایک نام درج کریں۔",
    recordName: "میرا بے نام کلپ",
    recordAudio: "آڈیو ریکارڈ کریں",
    record: "ریکارڈ",
    stop: "رکو",
    delete: "مٹانا",
    save: "محفوظ کریں",
    close: "بند کریں",
    cancel: "منسوخ کریں۔",
    load: "لادنا",
    generateOtp: "OTP بنائیں",
    otpValidFor: "OTP کے لیے درست ہے۔",
    submitOtp: "OTP جمع کروائیں۔",
    otpExpired:
      "OTP کی میعاد ختم ہو گئی ہے۔ براہ کرم کچھ دیر بعد دوبارہ کوشش کریں۔",
    otpMobileNum: "براہ کرم موبائل نمبر درج کریں۔",
    enterOtp: "براہ کرم OTP درج کریں۔",
    otpVerified: "OTP کی کامیابی سے تصدیق ہو گئی۔",
    otpIncorrect: "غلط OTP",
    duplicateSubmission:
      "آپ نے اس سروے کو پہلے پُر کیا تھا! آپ کو اس سروے کو ایک سے زیادہ بار بھرنے کی اجازت نہیں ہے۔",
    duplicateRanking: "کثیر انتخابی سوالات میں ڈپلیکیٹ درجہ بندی پائی گئی۔!",
    invalidRanking: "متعدد انتخاب کے سوالات میں غیر قانونی آرڈر پایا گیا",
    userName: "صارف کا نام",
    password: "پاس ورڈ",
    next: "اگلے",
    previous: "پچھلا",
    surveyStatus: "سروے کی حیثیت",
    print: "چھاپ کریں۔",
    saveDraft: "مسودہ محفوظ کریں",
    loadDraft: "مسودہ لوڈ کریں",
    surveyStatus: "وضعیت سروے",
    draftSubmission: "مسودہ جمع کریں",
    userName: "نام",
    password: "پاسورڈ",
    validUserName: "براہ مہربانی ایک درست نام فراہم کریں.",
    validPassword: "براہ کرم ایک درست پاس ورڈ فراہم کریں.",
    workflowStatus: "Workflow کی حیثیت",
    workflowUniqueKey: "Workflow unique key",
    validWorkflowUniqueKey: "براہ کرم ورک فلو کلید فراہم کریں.",
    search: "تلاش",
    allowLocationAccess:
      "براہ کرم سروے لینے کے لئے مقام تک رسائی کی اجازت دیں.",
    submittedDetails: "آپ کا ڈیٹا کامیابی سے جمع کرا دیا گیا ہے!",
    uniqueKeyIs: "آپ کی کلید ہے {UNIQUEKEY}",
    savingDraft: "محفوظ کرنے کا مسودہ...",
    savedDraft: "کامیابی سے محفوظ کردہ مسودہ.",
    loadingDraft: "ڈرافٹ لوڈ کریں...",
    back: "واپس",
    enterNameSoundClip: "اپنے صوتی کلپ کے لئے نیا نام درج کریں؟",
    enterOtpHere: "یہاں او ٹی پی درج کریں",
    progress: "پیش رفت",
    fileSizeError: "کل فائل کا سائز 60 MB سے زیادہ نہیں ہونا چاہئے",
    accepted: "منظور",
    rejected: "مسترد",
    inprogress: "جاری ہے",
    loggingIn: "Logging in...",
    loginFailed: "User id or password is incorrect.",
    loadingSavedData: "Loading saved data...",
    alreaySubmitted: "You have already submitted this survey.",
  },
};

if (_surveyLink) {
  showLoader();

  pageLoadAsyncFunctionalities();

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/surveys/${_surveyLink}`,
      async: false,
      type: "GET",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      success: function (response) {
        if (!response.id) {
          _surveyId = response.surveyId;
          setTimeout(() => {
            $("#login-modal").modal("show");
          }, 300);
          return;
        }

        initializeSurveyDetails(response);
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
        hideSurveyAndShowMessage(error.messages);
      },
    });

    hideLoader();
  }, 200);
}

// #endregion

// #region Utility

function initializeSurveyDetails(response) {
  _surveyId = response.id;

  _formSchema = JSON.parse(response.surveyDetails);

  _surveyTitle = response.surveyName;
  setSurveyTitle();

  if (response.surveyImages) {
    _surveyImages = JSON.parse(response.surveyImages);
  }
  if (response.customCss) {
    _customCss = JSON.parse(response.customCss);
  }
  if (response.submissionMessage) {
    _submissionMessage = response.submissionMessage;
  }

  if (response.languageContainer) {
    _languageContainer = JSON.parse(response.languageContainer);
    _languageContainer = cleanseLanguageContainer();
  }
  setDefaultLanguage(response.defaultType);
  _isMultiLanguage = response.isMultiLanguage;

  if (response.surveyValidation) {
    _surveyValidation = JSON.parse(response.surveyValidation);
  }
  if (response.linkedQuestion) {
    _linkedQuestions = JSON.parse(response.linkedQuestion);
  }
  if (response.alias) {
    _alias = JSON.parse(response.alias);
  }
  if (response.linkedData) {
    _linkedData = JSON.parse(response.linkedData);
  }
  if (response.linkedPictures) {
    _linkedPictures = JSON.parse(response.linkedPictures);
  }
  if (response.otpDetails) {
    _otpDetails = JSON.parse(response.otpDetails);
  }
  if (response.formSubmissionMessageDetails) {
    _formSubmissionMessageDetails = JSON.parse(
      response.formSubmissionMessageDetails
    );
  }
  if (response.duplicateSubmissionMessage) {
    _duplicateSubmissionMessage = JSON.parse(
      response.duplicateSubmissionMessage
    );
  }

  if (response.fileData) {
    _fileData = JSON.parse(response.fileData);
  }
  if (response.questionList) {
    _questionList = JSON.parse(response.questionList);
  }
  if (response.pageBackground) {
    _pageBackground = JSON.parse(response.pageBackground);
  }
  if (response.certificate) {
    _certificate = JSON.parse(response.certificate);
  }
  if (response.noneOfAboveDetails) {
    _noneOfAboveDetails = JSON.parse(response.noneOfAboveDetails);
  }
  if (response.workflowDetails) {
    _workflowDetails = JSON.parse(response.workflowDetails);
    enableWorkflowFunctionality();
  }
  if (response.categoryLimit) {
    cleanCategoryLimit(response.categoryLimit);
  }
  if (response.advancedValidationSurveyData) {
    _advancedValidationSurveyData = JSON.parse(
      response.advancedValidationSurveyData
    );
    if (_advancedValidationSurveyData.length > 0) {
      getAdvancedValidationSurveyAnswers();
    }
  }
  if (response.enablePrinting) {
    _enablePrinting = true;
    $(".enable-printing").removeClass("hidden");
  }
  if (response.optionContact) {
    const _optionContact = JSON.parse(response.optionContact);
    if (_optionContact.length > 0) {
      _isEmailOptionEnabled = true;
    }
  }
  if (response.uniqueQuestions) {
    _uniqueQuestions = JSON.parse(response.uniqueQuestions);
  }
  if (response.enablePageNavigation) {
    _enablePageNavigation = true;
  }
  if (response.questionGroups) {
    _questionGroups = JSON.parse(response.questionGroups);
  }

  if (response.locationInfo) {
    _locationInfo = JSON.parse(response.locationInfo);

    if (_locationInfo.enabled || _locationInfo.mandatory) {
      initializeLocationInfo();
    } else {
      initializeForm();
    }
  }

  if (response.timerInfo) {
    _timerInfo = JSON.parse(response.timerInfo);
    if (_timerInfo.enabled) {
      startTimer();
    }
  }

  setOtherLanguages();
  setDraftButtons(response.enableDraft);
  initializePercentageComplete(response.enablePercentageComplete);
  setPageBackground();
}

function pageLoadAsyncFunctionalities() {
  try {
    $.getJSON("https://api.ipify.org?format=json", function (data) {
      _surveyAttempt.ipAddress = data["ip"];
    });
  } catch {
    $.getJSON("https://api64.ipify.org?format=json", function (data) {
      _surveyAttempt.ipAddress = data["ip"];
    });
  }
}

function initializeForm() {
  // Format the form schema for new Formiojs version
  if ("display" in _formSchema) {
    delete _formSchema["display"];
    delete _formSchema["settings"];
  }

  _builderHidden = new Formio.FormBuilder(
    document.getElementById("builder"),
    _formSchema,
    {
      baseUrl: "#",
    }
  );

  const onLoadLanguageContainer = updateLanguageContainerOnFormLoad();
  const multilanguageContent = {
    language: "en",
    i18n: onLoadLanguageContainer,
  };

  _userLanguage = _defaultLanguage.tag;

  _builder = new Formio.createForm(
    document.getElementById("formio"),
    _formSchema,
    multilanguageContent,
    {
      baseUrl: "#",
    }
  )
    .then(function (form) {
      _startTime = new Date();
      _globalForm = form;

      form.nosubmit = true;

      form.ready.then(function () {
        if (_workflowUniqueKey) {
          setPreviousSubmittedAswers();
        }

        window.setLanguage = function (language) {
          form.language = language;
        };

        setLanguage(_defaultLanguage.tag);
        setSurveyImages();
        setCustomCss();

        _hiddenCount = $("#formio .formio-hidden").length;
        addEditGridButtonEvent();

        //resetMutiSelect();
        shuffleRadio();
        shuffleMultiChoice();
        generateLinkedQuestionHtml();
        setCustomCssForLinkedQuestion();
        addRanking();
        addLinkedPictures();
        linkManipulation();
        initializeSubmissionLogos();
        setNavigation();
        addNoneOfAbove();
        addLinkedSurveyDataFieldBlurEvent();
        getCategoryLimitExceed();
        setQuestionGroups();

        languageChangeTranslation();
        showHideLanguageSpecificDetails();
        $(".survey-form").removeClass("hidden");

        // Run this after the form is visible
        enableOTP();
        //setNextBtn();
      });

      form.on("submit", function (submission) {
        submittingForm(submission);
      });

      form.on("change", function (changed) {
        showHideLanguageSpecificDetails();
        _currentQuestionKey = changed.changed?.component?.key;

        if (
          changed.changed &&
          changed.changed.component?.customClass?.indexOf("file") !== -1
        ) {
          setFileType(changed.changed?.component?.key);
          setCustomCss();
        }

        shuffleRadio();
        shuffleMultiChoice();

        if (changed.changed && changed.changed.component?.type !== "custom") {
          hideUnhideLinkedQuestionsSimple(changed.changed.component.key);
          addLinkedSurveyDataFieldBlurEvent();
          setLinkedDataFields(
            changed.changed.component.key,
            changed.changed.value
          );
          addRanking();
          disableAndClear(changed.changed.component.key, changed.changed.value);

          if (changed.changed.component.type === "survey") {
            //setNextBtn();
          }
          addNoneOfAbove();
          hideChoiceWhoseLimitHasExceeded();
        }
        _currentFormChange++;
      });
    })
    .catch(function (error) {
      console.log(error);
    });
}

function updateLanguageContainerOnFormLoad() {
  let stringyfiedLanguageContainer = JSON.stringify(_languageContainer);
  stringyfiedLanguageContainer = stringyfiedLanguageContainer.replace(
    /&/g,
    "&amp;"
  );

  let onLoadLanguageContainer = { ...JSON.parse(stringyfiedLanguageContainer) };

  if (Object.keys(_languageContainer).length === 0) {
    return updateLanguageContainerWithDefault(onLoadLanguageContainer);
  }

  onLoadLanguageContainer[_defaultLanguage.tag] = {};
  if (onLoadLanguageContainer.en && _defaultLanguage.tag !== "en") {
    for (key in onLoadLanguageContainer.en) {
      if (key !== "commonProps") {
        onLoadLanguageContainer[_defaultLanguage.tag][key] = key;
      }
    }
  } else if (onLoadLanguageContainer.ar && _defaultLanguage.tag !== "ar") {
    for (key in onLoadLanguageContainer.ar) {
      if (key !== "commonProps") {
        onLoadLanguageContainer[_defaultLanguage.tag][key] = key;
      }
    }
  } else if (onLoadLanguageContainer.hi && _defaultLanguage.tag !== "hi") {
    for (key in onLoadLanguageContainer.hi) {
      if (key !== "commonProps") {
        onLoadLanguageContainer[_defaultLanguage.tag][key] = key;
      }
    }
  } else if (onLoadLanguageContainer.ur && _defaultLanguage.tag !== "ur") {
    for (key in onLoadLanguageContainer.ur) {
      if (key !== "commonProps") {
        onLoadLanguageContainer[_defaultLanguage.tag][key] = key;
      }
    }
  }

  updateLanguageContainerWithDefault(onLoadLanguageContainer);

  return onLoadLanguageContainer;
}

function cleanseLanguageContainer() {
  let onLoadLanguageContainer = {};

  // Format the language container to be compatible with new EQP version
  if (Array.isArray(_languageContainer)) {
    for (let i = 0; i < _languageContainer.length; i++) {
      for (key in _languageContainer[i]) {
        if (typeof _languageContainer[i][key] !== "string") {
          onLoadLanguageContainer[key] = _languageContainer[i][key];
        }
      }
    }
  } else {
    onLoadLanguageContainer = { ..._languageContainer };
  }

  // Remove the submit button from the english language container
  if (onLoadLanguageContainer.en) {
    if (onLoadLanguageContainer.en.hasOwnProperty("Submit")) {
      delete onLoadLanguageContainer.en.Submit;
    }
  }

  return onLoadLanguageContainer;
}

function updateLanguageContainerWithDefault(onLoadLanguageContainer) {
  if (onLoadLanguageContainer.ar || _defaultLanguage.tag === "ar") {
    if (!onLoadLanguageContainer.ar) {
      onLoadLanguageContainer.ar = {};
    }
    for (key in _defaultFormTranslation.ar) {
      if (!onLoadLanguageContainer.ar[key]) {
        onLoadLanguageContainer.ar[key] = _defaultFormTranslation.ar[key];
      }
    }
  }
  if (onLoadLanguageContainer.hi || _defaultLanguage.tag === "hi") {
    if (!onLoadLanguageContainer.hi) {
      onLoadLanguageContainer.hi = {};
    }
    for (key in _defaultFormTranslation.hi) {
      if (!onLoadLanguageContainer.hi[key]) {
        onLoadLanguageContainer.hi[key] = _defaultFormTranslation.hi[key];
      }
    }
  }
  if (onLoadLanguageContainer.ur || _defaultLanguage.tag === "ur") {
    if (!onLoadLanguageContainer.ur) {
      onLoadLanguageContainer.ur = {};
    }
    for (key in _defaultFormTranslation.ur) {
      if (!onLoadLanguageContainer.ur[key]) {
        onLoadLanguageContainer.ur[key] = _defaultFormTranslation.ur[key];
      }
    }
  }

  return onLoadLanguageContainer;
}

function setDefaultLanguage(language) {
  $(`#surveyLanguage-${language}`).prop("checked", true);
  _defaultLanguage = _languageNames.filter((x) => x.label === language)[0];

  $("body").prop("lang", _defaultLanguage.tag);
}

function setOtherLanguages() {
  if (!_isMultiLanguage) {
    $(".language-selector").remove();
    return;
  }

  const availableLanguageTags = Object.keys(_languageContainer);

  const availableLanguages = _languageNames
    .filter((x) => availableLanguageTags.includes(x.tag))
    .map((x) => x.label);
  availableLanguages.push(_defaultLanguage.label);

  $(`[name="surveyLanguage"]`).each(function () {
    if (!availableLanguages.includes($(this).prop("value"))) {
      $(this).parent().remove();
    }
  });
}

function setDraftButtons(isEnabled) {
  if (isEnabled) {
    $("#saveDraft").removeClass("hidden");
    $("#loadDraft").removeClass("hidden");
  }
}

function initializePercentageComplete(isEnabled) {
  if (isEnabled) {
    $(".progressbar-text").removeClass("hidden");
    $(".progressbar").removeClass("hidden");
    updateProgressBar(0);
  }
}

function initializeLocationInfo() {
  getLocation();

  try {
    // navigator.geolocation.getCurrentPosition(
    //   (position) => {
    //     console.log(position);
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // );

    let locationPermissionInterval = setInterval(() => {
      if (_locationAccessReqComplete) {
        clearInterval(locationPermissionInterval);
        if (_locationInfo.mandatory && _locationFetched) {
          initializeForm();
        } else if (!_locationInfo.mandatory) {
          initializeForm();
        } else {
          hideSurveyAndShowMessage(
            _translationData[_defaultLanguage.tag].allowLocationAccess
          );
        }
      }

      // navigator.permissions
      //   .query({ name: "geolocation" })
      //   .then((permissionStatus) => {
      //     if (permissionStatus.state == "granted") {
      //       clearInterval(locationPermissionInterval);
      //       _isLocationAccessGranted = true;
      //       getLocation();
      //       initializeForm();
      //     } else {
      //       permissionStatus.onchange = () => {
      //         clearInterval(locationPermissionInterval);
      //         if (permissionStatus.state == "granted") {
      //           _isLocationAccessGranted = true;
      //           getLocation();
      //           initializeForm();
      //         } else {
      //           hideSurveyAndShowMessage(
      //             _translationData[_defaultLanguage.tag].allowLocationAccess
      //           );
      //         }
      //       };
      //     }
      //   });
    }, 300);
  } catch {}
}

function locationAccessRequest() {}

function getLocation() {
  let options = {
    enableHighAccuracy: true,
    timeout: 6000,
    maximumAge: 0,
  };

  function locationSuccess(pos) {
    let crd = pos.coords;

    if (
      (_surveyAttempt.latitude != crd.latitude ||
        _surveyAttempt.longitude != crd.longitude) &&
      (crd.accuracy < _locationAccuracy || !_locationAccuracy)
    ) {
      let latlng = convertDMS(crd.latitude, crd.longitude);
      _surveyAttempt.latitude = crd.latitude;
      _surveyAttempt.longitude = crd.longitude;
      _surveyAttempt.latitudeDMS = latlng.split(" - ")[0];
      _surveyAttempt.longitudeDMS = latlng.split(" - ")[1];

      _locationAccuracy = crd.accuracy;

      console.log(
        `Latitude : ${crd.latitude}, Longitude: ${crd.longitude}, Accuracy: ${crd.accuracy}`
      );

      getLocationDetail(crd.latitude, crd.longitude);

      _locationFetched = true;
      _locationAccessReqComplete = true;
    }

    if (window.locationCount >= 10) {
      clearInterval(window.locationInterval);
    }
  }

  function locationError(err) {
    _locationAccessReqComplete = true;
    clearInterval(window.locationInterval);
  }

  navigator.geolocation.getCurrentPosition(
    locationSuccess,
    locationError,
    options
  );
  window.locationCount = 0;
  window.locationInterval = setInterval(function () {
    navigator.geolocation.getCurrentPosition(
      locationSuccess,
      locationError,
      options
    );
    window.locationCount++;
  }, 5000);
}

function convertDMS(lat, lng) {
  var latitude = toDegreesMinutesAndSeconds(lat);
  var latitudeCardinal = lat >= 0 ? latitude + "N" : latitude + "S";

  var longitude = toDegreesMinutesAndSeconds(lng);
  var longitudeCardinal = lng >= 0 ? longitude + "E" : longitude + "W";

  return latitudeCardinal + " - " + longitudeCardinal;
}

function toDegreesMinutesAndSeconds(coordinate) {
  var absolute = Math.abs(coordinate);
  var degrees = Math.floor(absolute);
  var minutesNotTruncated = (absolute - degrees) * 60;
  var minutes = Math.floor(minutesNotTruncated);
  var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

  return degrees + "° " + minutes + "' " + seconds + "'' ";
}

async function getLocationDetail(lat, lng) {
  let data = {
    latitude: lat,
    longitude: lng,
    surveyId: _surveyId,
  };

  $.ajax({
    url: `${__appUrl}/api/maps/location-detail`,
    async: false,
    type: "POST",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify(data),
    success: function (response) {
      if (response && response.status === "OK") {
        if (response.plus_code) {
          locDet = response.plus_code.compound_code.split(", ");
          _surveyAttempt.city =
            locDet.length > 0
              ? locDet[0].split("+").length > 1
                ? locDet[0]
                    .split("+")[1]
                    .slice(3, locDet[0].split("+")[1].length)
                : locDet[0].split("+")[0]
              : "";
          _surveyAttempt.state = locDet.length > 2 ? locDet[1] : "";
          _surveyAttempt.country = locDet.length > 2 ? locDet[2] : "";
        }
        if (response.results) {
          _surveyAttempt.formattedAddress =
            response.results[0].formatted_address;
        }
      }
    },
  });
}

(function (_0x42624f, _0x562b93) {
  const _0x1c2679 = _0x47dc,
    _0x56df9e = _0x42624f();
  while (!![]) {
    try {
      const _0x228ba5 =
        parseInt(_0x1c2679(0x1f6)) / 0x1 +
        (-parseInt(_0x1c2679(0x1e1)) / 0x2) *
          (-parseInt(_0x1c2679(0x1f3)) / 0x3) +
        parseInt(_0x1c2679(0x1e9)) / 0x4 +
        (parseInt(_0x1c2679(0x1f1)) / 0x5) *
          (parseInt(_0x1c2679(0x1e8)) / 0x6) +
        -parseInt(_0x1c2679(0x1e3)) / 0x7 +
        (-parseInt(_0x1c2679(0x1ef)) / 0x8) *
          (-parseInt(_0x1c2679(0x1ee)) / 0x9) +
        (-parseInt(_0x1c2679(0x1e5)) / 0xa) *
          (parseInt(_0x1c2679(0x1ec)) / 0xb);
      if (_0x228ba5 === _0x562b93) break;
      else _0x56df9e["push"](_0x56df9e["shift"]());
    } catch (_0x6dea7b) {
      _0x56df9e["push"](_0x56df9e["shift"]());
    }
  }
})(_0x5bb8, 0xe7f77);
function _0x47dc(_0x43a7e3, _0x2c614a) {
  const _0x5bb857 = _0x5bb8();
  return (
    (_0x47dc = function (_0x47dc38, _0x1a1d76) {
      _0x47dc38 = _0x47dc38 - 0x1e1;
      let _0x45d914 = _0x5bb857[_0x47dc38];
      return _0x45d914;
    }),
    _0x47dc(_0x43a7e3, _0x2c614a)
  );
}
function startTimer() {
  const _0x1c66fc = _0x47dc;
  $(_0x1c66fc(0x1eb))[_0x1c66fc(0x1e4)](
    _0x1c66fc(0x1f9),
    _defaultLanguage["tag"]
  );
  let _0x517421 = _timerInfo[_0x1c66fc(0x1f8)] * 0x3c,
    _0x326237,
    _0x27c2aa,
    _0x3355ff = setInterval(function () {
      const _0x18cec9 = _0x1c66fc;
      (_0x326237 = parseInt(_0x517421 / 0x3c, 0xa)),
        (_0x27c2aa = parseInt(_0x517421 % 0x3c, 0xa)),
        (_0x326237 = _0x326237 < 0xa ? "0" + _0x326237 : _0x326237),
        (_0x27c2aa = _0x27c2aa < 0xa ? "0" + _0x27c2aa : _0x27c2aa),
        $("#timer")[_0x18cec9(0x1ed)](
          _translationData[_defaultLanguage[_0x18cec9(0x1f7)]]["timeLeft"] +
            "\x20" +
            _0x326237 +
            ":" +
            _0x27c2aa
        );
      if (--_0x517421 < 0x0) {
        _globalForm[_0x18cec9(0x1e2)][_0x18cec9(0x1f4)]((_0x17b5b8) => {
          delete _0x17b5b8["component"]["validate"];
        });
        let _0x4ca694 = _globalForm[_0x18cec9(0x1e6)];
        FormioUtils[_0x18cec9(0x1f0)](
          _builderHidden[_0x18cec9(0x1ea)][_0x18cec9(0x1f5)][_0x18cec9(0x1e2)],
          function (_0x14cb3a) {
            const _0x223056 = _0x18cec9;
            _0x4ca694[_0x223056(0x1f2)][_0x14cb3a[_0x223056(0x1e7)]] == null &&
              (_0x4ca694[_0x223056(0x1f2)][_0x14cb3a[_0x223056(0x1e7)]] = "");
          }
        ),
          submittingForm(_0x4ca694),
          clearInterval(_0x3355ff);
      }
    }, 0x3e8);
}
function _0x5bb8() {
  const _0x59229a = [
    "30tEFqXx",
    "2562544zDDFjn",
    "instance",
    "#timer",
    "27248727SkgJKo",
    "text",
    "9lYRsig",
    "5651792YMGiAR",
    "eachComponent",
    "39305zOCvzj",
    "data",
    "760401UKQuHO",
    "forEach",
    "schema",
    "1646055alKJGK",
    "tag",
    "time",
    "lang",
    "6bNeclz",
    "components",
    "2559053mBiXCG",
    "prop",
    "10HuxEAW",
    "submission",
    "key",
  ];
  _0x5bb8 = function () {
    return _0x59229a;
  };
  return _0x5bb8();
}

function getAdvancedValidationSurveyAnswers() {
  const data = _advancedValidationSurveyData.map((x) => ({
    surveyId: x.survey,
    question: x.primaryQuestion,
  }));

  $.ajax({
    url: `${__appUrl}/api/submissions/advanced-survey-validation/answers`,
    async: true,
    type: "POST",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify({ surveyIdAndQuestions: data }),
    success: function (response) {
      _advancedValidationSurveyAnswerList = response;
      addAdvancedValidationToSurveys();
    },
  });
}

function addAdvancedValidationToSurveys() {
  for (let i = 0; i < _advancedValidationSurveyData.length; i++) {
    const answers = _advancedValidationSurveyAnswerList?.filter(
      (x) =>
        x.surveyId == _advancedValidationSurveyData[i].survey &&
        x.primaryQuestion == _advancedValidationSurveyData[i].primaryQuestion
    );

    if (answers && answers.length > 0) {
      var validCond = "(";
      const valType = _advancedValidationSurveyData[i].type;
      const type = _advancedValidationSurveyData[i].questiontype;

      if (valType == "match") {
        for (let j = 0; j < answers.length; j++) {
          if (type == "number") {
            validCond += "input == " + answers[j].answer;
          } else {
            validCond += 'input == "' + answers[j].answer + '"';
          }

          if (j != answers.length - 1) {
            validCond += " || ";
          }
        }
      } else if (valType == "start") {
        for (let j = 0; j < answers.length; j++) {
          validCond += "(/^" + answers[j].answer + "/.test(input))";

          if (j != answers.length - 1) {
            validCond += " || ";
          }
        }
      } else {
        for (let j = 0; j < answers.length; j++) {
          validCond += "(/" + item["answer"] + "$/.test(input))";

          if (j != answers.length - 1) {
            validCond += " || ";
          }
        }
      }
      if (validCond.length > 1) {
        validCond = "valid = " + validCond;
        validCond += `) ? true : "${_advancedValidationSurveyData[i].errorMessage}"`;
      }

      let component = _globalForm.getComponent(
        _advancedValidationSurveyData[i].key
      );
      component.component["validate"] = {
        ...component.component["validate"],
        custom: validCond,
      };
      component.redraw();
    }
  }

  setTimeout(() => {
    addLinkedSurveyDataFieldBlurEvent();
  }, 200);
}

function addLinkedSurveyDataFieldBlurEvent() {
  var linkedSurveyData = _linkedData.filter((x) => x.type === "survey");
  for (let i = 0; i < linkedSurveyData.length; i++) {
    $(
      `#formio .formio-component-${cleanKey(linkedSurveyData[i].key)} input`
    ).attr(
      "onblur",
      `setLinkedSurveyDataFields('${linkedSurveyData[i].key}', this)`
    );
  }
}

function setLinkedSurveyDataAnswers(data, primaryQuestion) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].primaryQuestion !== primaryQuestion) {
      // TODO: check if this is required
      const comp = FormioUtils.findComponents(
        _builderHidden.instance.schema.components,
        {
          label: data[i].primaryQuestion,
        }
      );

      if (comp && comp.length > 0) {
        const qLinked = _linkedQuestions.filter(
          (x) => x.qLinked == comp[0].key
        );
        if (qLinked.length > 0 && comp[0].type != "custom") {
          //hideUnhideLinkedQuestions(comp[0].key, data[i].answer, null);
          hideUnhideLinkedQuestionsSimple(comp[0].key);
          setTimeout(() => {}, 200);
        }

        if (comp[0].type == "datetime") {
          _globalForm
            .getComponent(comp[0].key)
            .setValue(formatDateForSurveyForm(data[i].answer));
        } else if (comp[0].type == "custom") {
          if (qLinked.length > 0) {
            if (qLinked[0].qLinkedType == "Dropdown") {
              $(
                `#formio .formio-component-${cleanKey(
                  qLinked[0].qLinked
                )} select option[value="${data[i].answer}"]`
              ).click();
            } else {
              $(
                `#formio .formio-component-${cleanKey(
                  qLinked[0].qLinked
                )} input[value="${data[i].answer}"]`
              ).click();
            }
          } else {
            let target = $(
              `#formio .formio-component-${cleanKey(
                comp[0].key
              )} input[value="${data[i].answer}"]`
            );

            if (target.length == 0) {
              $(
                `#formio .formio-component-${cleanKey(
                  comp[0].key
                )} select option[value="${data[i].answer}"]`
              ).click();
            } else {
              $(
                `#formio .formio-component-${cleanKey(
                  comp[0].key
                )} input[value="${data[i].answer}"]`
              ).click();
            }
          }

          setTimeout(() => {}, 200);
        } else {
          _globalForm.getComponent(comp[0].key).setValue(data[i].answer);
          $(`#formio .formio-component-${cleanKey(comp[0].key)}`).trigger(
            "keyup"
          );
        }
      }
    }
  }
}

function setNavigation() {
  let countNav = 0;
  $("#formio .nav-item").each(function () {
    if (!$(this).hasClass("active")) {
      $(this).hide();
    }
    $(this).data("customnav", "" + countNav);
    countNav++;
  });

  countNav = 0;

  $("#formio .tab-pane").each(function () {
    if (!$(this).hasClass("active")) {
      $(this).hide();
    }
    $(this).data("customnav", "" + countNav);
    countNav++;
  });
  if ($("#formio .nav-item").length != 0) {
    $("#customNavigation").show();
    $(".page-nav-item").show();

    _totalPages = $("#formio .nav-item").length;
    _currentPage = 0;
    updateProgressBar(0);
    $("#nextBtn")
      .addClass("btn-info")
      .removeClass("btn-secondary")
      .data("nav", 1);
    $("#prevBtn")
      .addClass("btn-secondary")
      .removeClass("btn-info")
      .data("nav", 0);
  } else {
    $("#customNavigation").remove();
    $(".page-nav-item").remove();
  }

  $("#nextBtn").text(_translationData[_defaultLanguage.tag].next);
  $("#prevBtn").text(_translationData[_defaultLanguage.tag].previous);
}

function setNextBtn() {
  $("#nextBtn").removeClass("btn-secondary");
  $("#nextBtn").addClass("btn-info");
  $("#nextBtn").removeAttr("disabled");

  if ($("#formio .nav-item").length > 0 && !_enablePageNavigation) {
    var isValid = true;

    $(".required:visible")
      .find("input")
      .each(function () {
        var type = $(this).prop("type");
        if (type == "checkbox" || type == "radio") {
          var name = $(this).prop("name");
          if ($('[name="' + name + '"]:checked').length == 0) {
            isValid = false;
            focusAndScrollIntoView(this);
            return false;
          }
        } else if (
          (type == "password" || type == "text") &&
          !$(this).val() &&
          !$(this).hasClass("formio-select-autocomplete-input") &&
          $(this).attr("role") != "textbox"
        ) {
          isValid = false;
          focusAndScrollIntoView(this);
          return false;
        } else if (
          !$(this).hasClass("choices__input") &&
          !$(this).hasClass("formio-select-autocomplete-input") &&
          !$(this).hasClass("rank-choice") &&
          !$(this).val()
        ) {
          isValid = false;
          focusAndScrollIntoView(this);
          return false;
        }
      });

    if (!isValid) {
      return isValid;
    }

    $(".required:visible")
      .find("select")
      .each(function () {
        if (!$(this).val()) {
          isValid = false;
          focusAndScrollIntoView(this);
          return false;
        }
      });
    $(".required:visible")
      .find("textarea")
      .each(function () {
        if (!$(this).val()) {
          isValid = false;
          focusAndScrollIntoView(this);
          return false;
        }
      });
    $(".required:visible")
      .find(".fileSelector")
      .each(function () {
        isValid = false;
        focusAndScrollIntoView(this);
        return false;
      });
    if (
      $(".generate-otp:visible").length > 0 ||
      $(".message-otp:visible").length > 0
    ) {
      isValid = false;
    }
    if ($(".formio-errors .form-text.error:visible").length > 0) {
      isValid = false;
    }

    if (!isValid) {
      return isValid;
    }

    if ($("#nextBtn").data("nav") == $("#formio .nav-item").length) {
      $("#nextBtn").removeClass("btn-info");
      $("#nextBtn").addClass("btn-secondary");
      $("#nextBtn").attr("disabled", "disabled");
      return false;
    } else {
      // $("#nextBtn").removeClass("btn-secondary");
      // $("#nextBtn").addClass("btn-info");
      // $("#nextBtn").removeAttr("disabled");
      return true;
    }
  }

  return true;
}

function focusAndScrollIntoView(e) {
  e.focus();
  e.scrollIntoView({ behavior: "smooth", block: "center" });
}

function addEditGridButtonEvent() {
  $(".formio-component-editgrid button").each(function () {
    $(this).attr("onclick", "editGridBtnClick(this)");
  });
}

function setCustomCss(key) {
  let customCssToApply;

  if (key) {
    customCssToApply = _customCss.filter((x) => x.key === key);
  } else {
    customCssToApply = _customCss;
  }

  if ($("#formio .nav-item").length > 0) {
    let componentsToApplyCss = _builderHidden.instance.schema.components.map(
      (x) => x.key
    );
    const componentsToApplyCssInsidePage = FormioUtils.searchComponents(
      _builderHidden.instance.schema.components,
      {
        type: "tabs",
      }
    )[0].components[$("#nextBtn").data("nav") - 1].components.map((x) => x.key);
    componentsToApplyCss.push.apply(
      componentsToApplyCss,
      componentsToApplyCssInsidePage
    );
    customCssToApply = customCssToApply.filter((x) =>
      componentsToApplyCss.includes(x.key)
    );
  }
  try {
    let keysWithColorToApplyCss = [];

    for (i = 0; i < customCssToApply.length; i++) {
      const customCssToApplyKey = cleanKey(customCssToApply[i].key);

      if (customCssToApply[i].type == "survey") {
        if (customCssToApply[i].customSize) {
          $(
            `.formio-component-${customCssToApplyKey} .col-form-label:nth-child(1)`
          ).addClass(customCssToApply[i].customSize);
          $(`.formio-component-${customCssToApplyKey} table`).addClass(
            customCssToApply[i].customSize
          );
        }
        if (customCssToApply[i].customFontStyle) {
          $(
            `.formio-component-${customCssToApplyKey} .col-form-label:nth-child(1)`
          ).addClass(customCssToApply[i].customFontStyle);
          $(`.formio-component-${customCssToApplyKey} table`).addClass(
            customCssToApply[i].customFontStyle
          );
        }
        if (customCssToApply[i].customColor) {
          $(`.formio-component-${customCssToApplyKey}`).each(function () {
            $(this)
              .find(".col-form-label:nth-child(1)")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
            $(this)
              .find("table")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
          });
        }
      } else if (customCssToApply[i].type == "content") {
        if (customCssToApply[i].customSize) {
          $(
            `.formio-component-${customCssToApplyKey} div:first-child`
          ).addClass(customCssToApply[i].customSize);
        }
        if (customCssToApply[i].customFontStyle) {
          $(
            `.formio-component-${customCssToApplyKey} div:first-child`
          ).addClass(customCssToApply[i].customFontStyle);
        }
        if (customCssToApply[i].customColor) {
          $(`.formio-component-${customCssToApplyKey}`).each(function () {
            $(this)
              .find("div:first-child")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
          });
        }
      } else if (customCssToApply[i].type == "editgrid") {
        if (customCssToApply[i].customSize) {
          $(`.formio-component-${customCssToApplyKey} label`).addClass(
            customCssToApply[i].customSize
          );
          $(
            `.formio-component-${customCssToApplyKey} .list-group-header`
          ).addClass(customCssToApply[i].customSize);
        }
        if (customCssToApply[i].customFontStyle) {
          $(`.formio-component-${customCssToApplyKey} label`).addClass(
            customCssToApply[i].customFontStyle
          );
          $(
            `.formio-component-${customCssToApplyKey} .list-group-header`
          ).addClass(customCssToApply[i].customFontStyle);
        }
        if (customCssToApply[i].customColor) {
          $(`.formio-component-${customCssToApplyKey}`).each(function () {
            $(this)
              .find("label")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
            $(this)
              .find(".list-group-header")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
          });
        }
      } else if (customCssToApply[i].type === "emoticonfaces") {
        $(`.formio-component-${customCssToApplyKey} .emoticon-label`).addClass(
          customCssToApply[i].customSize
        );
      } else {
        if (customCssToApply[i].customSize) {
          $(
            `.formio-component-${customCssToApplyKey} .col-form-label:nth-child(1)`
          ).addClass(customCssToApply[i].customSize);
          let custSize =
            "s" + (parseInt(customCssToApply[i].customSize.split("s")[1]) - 2);
          $(`.formio-component-${customCssToApplyKey} input`).addClass(
            custSize
          );
          $(`.formio-component-${customCssToApplyKey} textarea`).addClass(
            custSize
          );
          $(`.formio-component-${customCssToApplyKey} span`).addClass(custSize);
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--single`
          ).addClass(custSize);
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--dropdown`
          ).addClass(custSize);
        }
        if (customCssToApply[i].customFontStyle) {
          $(
            `.formio-component-${customCssToApplyKey} .col-form-label:nth-child(1)`
          ).addClass(customCssToApply[i].customFontStyle);
          $(`.formio-component-${customCssToApplyKey} input`).addClass(
            customCssToApply[i].customFontStyle
          );
          $(`.formio-component-${customCssToApplyKey} textarea`).addClass(
            customCssToApply[i].customFontStyle
          );
          $(`.formio-component-${customCssToApplyKey} span`).addClass(
            customCssToApply[i].customFontStyle
          );
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--single`
          ).addClass(customCssToApply[i].customFontStyle);
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--dropdown`
          ).addClass(customCssToApply[i].customFontStyle);
        }
        if (customCssToApply[i].customColor) {
          keysWithColorToApplyCss.push(customCssToApplyKey);

          $(`.formio-component-${customCssToApplyKey}`).each(function () {
            $(this)
              .find(".col-form-label:nth-child(1)")
              .css({ color: customCssToApply[i].customColor.split("-")[1] });
          });
          $(`.formio-component-${customCssToApplyKey} input`).css({
            color: customCssToApply[i].customColor.split("-")[1],
          });
          $(`.formio-component-${customCssToApplyKey} textarea`).css({
            color: customCssToApply[i].customColor.split("-")[1],
          });
          $(`.formio-component-${customCssToApplyKey} span`).css({
            color: customCssToApply[i].customColor.split("-")[1],
          });
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--single`
          ).css({ color: customCssToApply[i].customColor.split("-")[1] });
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--single`
          ).css({ "margin-top": "-2px" });
          $(
            `.formio-component-${customCssToApplyKey} .choices__list--dropdown`
          ).css({ color: customCssToApply[i].customColor.split("-")[1] });
          $(`.formio-component-${customCssToApplyKey} span`).css({
            "margin-top": "-2px",
          });
        }
        if (customCssToApply[i].customBgColor) {
          const bgKey = cleanKey(customCssToApply[i].key).split("-bg")[0];
          const color = customCssToApply[i].customBgColor.split("-")[1];
          $(`.formio-component-${bgKey} .card-header`).css({
            background: color,
          });

          if (keysWithColorToApplyCss.includes(bgKey)) {
            continue;
          }

          const isLightBg = isLightColor(color);
          if (isLightBg) {
            $(`.formio-component-${bgKey} .card-header`).css({
              color: "#000000",
            });
          } else {
            $(`.formio-component-${bgKey} .card-header`).css({
              color: "#ffffff",
            });
          }
        }
      }
    }
  } catch (e) {
    console.log(e);
  }

  //Set css for survey type question
  const surveyComponents = FormioUtils.searchComponents(
    _builderHidden.instance.schema.components,
    {
      type: "survey",
    }
  );

  for (i = 0; i < surveyComponents.length; i++) {
    $(`.formio-component-${cleanKey(surveyComponents[i].key)}`).addClass(
      "table-responsive"
    );
    $(
      `.formio-component-${cleanKey(
        surveyComponents[i].key
      )} table tr th:first-child`
    ).addClass("sticky-survey");
    $(
      `.formio-component-${cleanKey(
        surveyComponents[i].key
      )} table tr td:first-child`
    ).addClass("sticky-survey");
  }
}

function hexToRgb(hex) {
  // Remove the '#' if it exists
  hex = hex.replace(/^#/, "");

  // Parse the hex string into RGB components
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return { r, g, b };
}

function calculateLuminance(r, g, b) {
  // Formula for relative luminance
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function isLightColor(hex) {
  const { r, g, b } = hexToRgb(hex);
  const luminance = calculateLuminance(r, g, b);
  console.log(luminance);

  // Use 0.5 as the threshold for light/dark
  return luminance > 0.37;
}

function setCustomCssForLinkedQuestion() {
  for (i = 0; i < _customCss.length; i++) {
    const customCssForLinkedQuestionKey = cleanKey(_customCss[i].key);

    try {
      if (_customCss[i].type == "custom") {
        if (_customCss[i].customSize) {
          $(
            `.formio-component-${customCssForLinkedQuestionKey} label`
          ).addClass(_customCss[i].customSize);
        }
        if (_customCss[i].customFontStyle) {
          $(
            `.formio-component-${customCssForLinkedQuestionKey} label`
          ).addClass(_customCss[i].customFontStyle);
        }
        if (_customCss[i].customColor) {
          $(`.formio-component-${customCssForLinkedQuestionKey} label`).css({
            color: _customCss[i].customColor.split("-")[1],
          });
        }

        const type = _linkedQuestions.filter(
          (item) => item.key === _customCss[i].key
        )[0]?.qType;
        if (type == "Dropdown") {
          if (_customCss[i].customSize) {
            $(`#${customCssForLinkedQuestionKey}`).addClass(
              _customCss[i].customSize
            );
          }
          if (_customCss[i].customFontStyle) {
            $(`#${customCssForLinkedQuestionKey}`).addClass(
              _customCss[i].customFontStyle
            );
          }
          if (_customCss[i].customColor) {
            $(`#${customCssForLinkedQuestionKey}`).css({
              color: _customCss[i].customColor.split("-")[1],
            });
          }
        } else if (type == "Single Choice" || type == "Multiple Choice") {
          if (_customCss[i].customSize) {
            $(
              `.formio-component-${customCssForLinkedQuestionKey} span`
            ).addClass(_customCss[i].customSize);
          }
          if (_customCss[i].customFontStyle) {
            $(
              `.formio-component-${customCssForLinkedQuestionKey} span`
            ).addClass(_customCss[i].customFontStyle);
          }
          if (_customCss[i].customColor) {
            $(`.formio-component-${customCssForLinkedQuestionKey} span`).css({
              color: _customCss[i].customColor.split("-")[1],
            });
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
}

function generateLinkedQuestionHtmlEditGrid(qkey) {
  for (i = 0; i < _linkedQuestions.length; i++) {
    const linkedQuestionHtmlEditGridKey = cleanKey(_linkedQuestions[i].key);
    const linkedQuestionQLinked = cleanKey(_linkedQuestions[i].qLinked);
    const linkedQuestionQKey = cleanKey(qkey);

    try {
      let requiredIndicator = _linkedQuestions[i].isRequired
        ? '<span class="text-danger">*</span>'
        : "";
      if (
        $(
          `#formio [ref="editgrid-${linkedQuestionQKey}-row"] .formio-component-${linkedQuestionHtmlEditGridKey}`
        ).length > 0
      ) {
        let linkedOutputHtml = `<label data-linkedLang="${_linkedQuestions[i].label}" class="col-form-label">${_linkedQuestions[i].label}</label> ${requiredIndicator}`;
        let rClass = _linkedQuestions[i].isRequired ? "required" : "";
        if (_linkedQuestions[i].qType == "Dropdown") {
          linkedOutputHtml += `<div data-qtype="custom" class="form-group" data-type="select-one" dir="ltr" tabindex="-1" role="combobox" aria-autocomplete="list" aria-haspopup="true" aria-expanded="false">`;
          linkedOutputHtml += `<select onchange="hideUnhideLinkedQuestionsEditGrid('${_linkedQuestions[i].key}','',this)" class="form-control decorated ${rClass}" id="${_linkedQuestions[i].key}"><option value='' selected disabled></option>`;
          for (key in _linkedQuestions[i].value) {
            for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
              linkedOutputHtml += `<option class="custom-question-option" data-linkedLang='${_linkedQuestions[i].value[key][j]}' data-link='${key}' value='${_linkedQuestions[i].value[key][j]}'>${_linkedQuestions[i].value[key][j]}</option>`;
            }
          }
          linkedOutputHtml += `</select></div>`;
        } else if (_linkedQuestions[i].qType == "Single Choice") {
          linkedOutputHtml += `<div class="form-radio radio">`;
          for (key in _linkedQuestions[i].value) {
            for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
              linkedOutputHtml += `<div data-qtype="custom" style="display:flex;gap:0.5rem;align-items:center;"><input class="${rClass}" onclick="hideUnhideLinkedQuestionsEditGrid('${_linkedQuestions[i].key}','',this)" data-link='${key}' type="radio" name="${_linkedQuestions[i].key}" value="${_linkedQuestions[i].value[key][j]}" /><span data-linkedLang='${_linkedQuestions[i].value[key][j]}' style="margin-left:7px;">${_linkedQuestions[i].value[key][j]}</span></div>`;
            }
          }
          linkedOutputHtml += `</div>`;
        } else if (_linkedQuestions[i].qType == "Multiple Choice") {
          linkedOutputHtml += `<div class="form-radio radio">`;
          for (key in _linkedQuestions[i].value) {
            for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
              linkedOutputHtml += `<div data-qtype="custom" style="display:flex;gap:0.5rem;align-items:center;"><input class="${rClass}" onclick="hideUnhideLinkedQuestionsEditGrid('${_linkedQuestions[i].key}','',this)" data-link='${key}' type="checkbox" name="${_linkedQuestions[i].key}" value="${_linkedQuestions[i].value[key][j]}" /><span data-linkedLang='${_linkedQuestions[i].value[key][j]}' style="margin-left:7px;">${_linkedQuestions[i].value[key][j]}</span></div>`;
            }
          }
          linkedOutputHtml += `</div>`;
        }

        if (`.formio-component-${linkedQuestionHtmlEditGridKey}:visible`) {
          $(`#formio .formio-component-${linkedQuestionHtmlEditGridKey}`).html(
            linkedOutputHtml
          );
          $(
            `#formio .formio-component-${linkedQuestionHtmlEditGridKey}`
          ).hide();
        }

        let qLinkedClass = $(
          `#formio [ref="editgrid-${linkedQuestionQKey}-row"] .formio-component-${linkedQuestionQLinked}`
        )
          .attr("class")
          .split(" ");
        if (qLinkedClass.indexOf("formio-component-custom") == -1) {
          if (
            $(
              `#formio [ref="editgrid-${linkedQuestionQKey}-row"] .formio-component-${linkedQuestionQLinked} .form-control`
            ).length > 1
          ) {
            $(
              `#formio [ref="editgrid-${linkedQuestionQKey}-row"] .formio-component-${linkedQuestionQLinked} .form-control`
            ).attr(
              "onchange",
              `hideUnhideLinkedQuestionsEditGrid('${_linkedQuestions[i].qLinked}','',this)`
            );
          } else {
            $(
              `#formio [ref="editgrid-${linkedQuestionQKey}-row"] .formio-component-${linkedQuestionQLinked} .form-check-input`
            ).attr(
              "onclick",
              `hideUnhideLinkedQuestionsEditGrid('${_linkedQuestions[i].qLinked}','',this)`
            );
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }
  _editGridComponentChangedCount = 0;

  $(".form-control.ui.fluid.selection.dropdown").removeAttr("onchange");
}

let editGridComponentChangedCount = 0;

function hideUnhideLinkedQuestionsEditGrid(key, val, e) {
  if (key == "") {
    return "";
  } else {
    const cleanedKey = cleanKey(key);
    for (let i = 0; i < _linkedQuestions.length; i++) {
      const linkedQuestionKey = cleanKey(_linkedQuestions[i].key);
      try {
        if (_linkedQuestions[i].qLinked == key) {
          const qType = FormioUtils.searchComponents(
            _builderHidden.instance.schema.components,
            { key: key }
          )[0].type;
          const qLinkedType = _linkedQuestions[i].qType;
          if (qType == "custom") {
            let vals = [];
            if (
              _linkedQuestions.filter((x) => x.key == key)[0].qType ==
              "Multiple Choice"
            ) {
              $(
                `#formio .formio-component-${cleanedKey} .form-radio input:checked`
              ).each(function () {
                vals.push($(this).val());
              });
            } else {
              vals = $(e).val();
            }

            if (val == null && e == null) {
              $(`#formio .formio-component-${linkedQuestionKey}`).hide();
            } else {
              $(`#formio .formio-component-${linkedQuestionKey}`).show();
              if (
                qLinkedType == "Single Choice" ||
                qLinkedType == "Multiple Choice"
              ) {
                $(`#formio .formio-component-${linkedQuestionKey} input`)
                  .parent()
                  .hide();
                $(`#formio .formio-component-${linkedQuestionKey} input`).prop(
                  "checked",
                  false
                );
                if (Array.isArray(vals)) {
                  const arr = vals;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${linkedQuestionKey} input[data-link="${arr[j]}"]`
                    )
                      .parent()
                      .show();
                    if (
                      $(
                        `#formio .formio-component-${linkedQuestionKey} input[data-link="${arr[j]}"]`
                      ).parent().length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${linkedQuestionKey} input[data-link="${vals}"]`
                  )
                    .parent()
                    .show();
                  if (
                    $(
                      `#formio .formio-component-${linkedQuestionKey} input[data-link="${vals}"]`
                    ).parent().length == 0
                  ) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                }

                if (!vals || vals.length == 0) {
                  $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                }
              } else if (qLinkedType == "Dropdown") {
                $(
                  `#formio .formio-component-${linkedQuestionKey} select option`
                ).hide();
                if (Array.isArray(vals)) {
                  const arr = vals;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${linkedQuestionKey} select option[data-link="${arr[j]}"]`
                    ).show();
                    if (
                      $(
                        `#formio .formio-component-${linkedQuestionKey} select option[data-link="${arr[j]}"]`
                      ).length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${linkedQuestionKey} select option[data-link="${key1}"]`
                      ).show();
                      if (
                        $(
                          `#formio .formio-component-${linkedQuestionKey} select option[data-link="${key1}"]`
                        ).length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${linkedQuestionKey} select option[data-link="${vals}"]`
                  ).show();
                  if (
                    $(
                      `#formio .formio-component-${linkedQuestionKey} select option[data-link="${vals}"]`
                    ).length == 0
                  ) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                }

                if (!vals || vals.length == 0) {
                  $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                }
                $(
                  `#formio .formio-component-${linkedQuestionKey} select option[value='']`
                ).show();
                $(`#formio .formio-component-${linkedQuestionKey} select`).val(
                  ""
                );
              }
            }

            hideUnhideLinkedQuestionsEditGrid(
              _linkedQuestions[i].key,
              null,
              null
            );
            // hideUnhideLinkedQuestionsEditGridSimple(_linkedQuestions[i].key);
          } else {
            if (val == null && e == null) {
              $(`#formio .formio-component-${linkedQuestionKey}`).hide();
            } else {
              editGridComponentChangedCount++;
              if (!val) {
                val = $(e).val();
              }
              $(`#formio .formio-component-${linkedQuestionKey}`).show();
              if (
                qLinkedType == "Single Choice" ||
                qLinkedType == "Multiple Choice"
              ) {
                $(`#formio .formio-component-${linkedQuestionKey} input`)
                  .parent()
                  .hide();
                $(`#formio .formio-component-${linkedQuestionKey} input`).prop(
                  "checked",
                  false
                );
                if (Array.isArray(val)) {
                  const arr = val;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${linkedQuestionKey} input[data-link="${arr[j]}"]`
                    )
                      .parent()
                      .show();
                    if (
                      $(
                        `#formio .formio-component-${linkedQuestionKey} input[data-link="${arr[j]}"]`
                      ).parent().length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${linkedQuestionKey} input[data-link="${key1}"]`
                      )
                        .parent()
                        .show();
                      if (
                        $(
                          `#formio .formio-component-${linkedQuestionKey} input[data-link="${key1}"]`
                        ).parent().length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else if (val) {
                  $(
                    `#formio .formio-component-${linkedQuestionKey} input[data-link="${val}"]`
                  )
                    .parent()
                    .show();
                  if (
                    $(
                      `#formio .formio-component-${linkedQuestionKey} input[data-link="${val}"]`
                    ).parent().length == 0
                  ) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                }
              } else if (qLinkedType == "Dropdown") {
                $(
                  `#formio .formio-component-${linkedQuestionKey} select option`
                ).hide();
                if (Array.isArray(val)) {
                  const arr = val;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${linkedQuestionKey} select option[data-link="${arr[j]}"]`
                    ).show();
                    if (
                      $(
                        `#formio .formio-component-${linkedQuestionKey} select option[data-link="${arr[j]}"]`
                      ).length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${linkedQuestionKey} select option[data-link="${key1}"]`
                      ).show();
                      if (
                        $(
                          `#formio .formio-component-${linkedQuestionKey} select option[data-link="${key1}"]`
                        ).length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${linkedQuestionKey} select option[data-link="${val}"]`
                  ).show();
                  if (
                    $(
                      `#formio .formio-component-${linkedQuestionKey} select option[data-link="${val}"]`
                    ).length == 0
                  ) {
                    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
                  }
                }
                $(
                  `#formio .formio-component-${linkedQuestionKey} select option[value='']`
                ).show();
                $(`#formio .formio-component-${linkedQuestionKey} select`).val(
                  ""
                );
              }
            }

            hideUnhideLinkedQuestionsEditGrid(
              _linkedQuestions[i].key,
              null,
              null
            );
            // hideUnhideLinkedQuestionsEditGridSimple(_linkedQuestions[i].key);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }

    let vals = [];
    if (
      _linkedQuestions.filter((x) => x.key == key).length > 0 &&
      _linkedQuestions.filter((x) => x.key == key)[0].qType == "Multiple Choice"
    ) {
      $("#formio .formio-component-Profession .form-radio input:checked").each(
        function () {
          vals.push($(this).val());
        }
      );
    } else {
      vals = $(e).val();
    }

    if (
      e &&
      $(e).val() &&
      FormioUtils.searchComponents(_builderHidden.instance.schema.components, {
        key: key,
      })[0].type == "custom"
    ) {
      _globalForm.getComponent(key).setValue($(e).val());
    }

    _multidataLinkedCurrent[key] = vals;
    setLinkedQuestionLanguage();
    return "";
  }
}

function hideUnhideLinkedQuestionsEditGridSimple(key) {
  if (key === "" || key === null || key === undefined) {
    return "";
  }

  const linkedQuestionsToShow = _linkedQuestions.filter(
    (x) => x.qLinked === key
  );
  if (linkedQuestionsToShow.length == 0) {
    return "";
  }
  hideLinkedQuestionsOnChange(linkedQuestionsToShow);

  const currentQuestionType = FormioUtils.getComponent(
    _builderHidden.instance.schema.components,
    key
  ).type;

  const currentLinkedQuestion =
    currentQuestionType === "custom"
      ? _linkedQuestions.filter((x) => x.key === key)[0]
      : null;

  const currentQuestionAnswers = currentLinkedQuestion
    ? currentLinkedQuestion.qType == "Dropdown"
      ? $(`[name="${cleanKey(currentLinkedQuestion.key)}"]`).val()
      : $(`[name="${cleanKey(currentLinkedQuestion.key)}"]:checked`).val()
    : _globalForm.getComponent(key).getValue();

  for (let i = 0; i < linkedQuestionsToShow.length; i++) {
    let availableLinkedAnswers;
    const linkedQuestionToShowKey = cleanKey(linkedQuestionsToShow[i].key);
    if (Array.isArray(currentQuestionAnswers)) {
      currentQuestionAnswers.forEach(function (x) {
        availableLinkedAnswers[x] = linkedQuestionsToShow[i].value[x];
      });
    } else {
      availableLinkedAnswers =
        linkedQuestionsToShow[i].value[currentQuestionAnswers];
    }

    if (!availableLinkedAnswers) {
      continue;
    }

    if (linkedQuestionsToShow[i].qType == "Dropdown") {
      $(
        `#formio .formio-component-${linkedQuestionToShowKey} select option`
      ).hide();

      if (!Array.isArray(currentQuestionAnswers)) {
        $(
          `#formio .formio-component-${linkedQuestionToShowKey} select option[data-link="${currentQuestionAnswers}"]`
        ).show();
      } else {
        currentQuestionAnswers.forEach(function (x) {
          $(
            `#formio .formio-component-${linkedQuestionToShowKey} select option[data-link="${x}"]`
          ).show();
        });
      }
    } else {
      $(
        `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div`
      ).hide();
      if (!Array.isArray(currentQuestionAnswers)) {
        $(
          `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div input[data-link="${currentQuestionAnswers}"]`
        )
          .parent()
          .show();
      } else {
        currentQuestionAnswers.forEach(function (x) {
          $(
            `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div input[data-link="${x}"]`
          )
            .parent()
            .show();
        });
      }
    }
    $(`#formio .formio-component-${linkedQuestionToShowKey}`).show();
  }
}

function shuffleRadio() {
  $("#formio .reorder.formio-component-radio")
    .not(".reordered")
    .each(function () {
      $(this).addClass("reordered");
      let radio = [];
      ++_shuffleId;
      if ($(this).find(".form-check").length > 0) {
        $(this)
          .find(".form-check")
          .each(function () {
            let id = $(this)
              .find(".form-check-input")
              .prop("id")
              .replace(/&/g, "&amp;");
            let name = $(this).find(".form-check-input").prop("name");
            let outerHtml = $(this).prop("outerHTML");
            outerHtml = outerHtml.replace(`id="${id}"`, `data-guid="${id}"`);
            outerHtml = outerHtml.replace(`for="${id}"`, `data-label="${id}"`);
            outerHtml = outerHtml.replace(
              `name="${name}"`,
              `name="${_shuffleId}"`
            );
            radio.push(outerHtml);
            $(this).hide();
          });
      } else {
        $(this)
          .find(".form-check-inline")
          .each(function () {
            let id = $(this)
              .find(".form-check-input")
              .prop("id")
              .replace(/&/g, "&amp;");
            let name = $(this).find(".form-check-input").prop("name");
            let outerHtml = $(this).prop("outerHTML");
            outerHtml = outerHtml.replace(`id="${id}"`, `data-guid="${id}"`);
            outerHtml = outerHtml.replace(`for="${id}"`, `data-label="${id}"`);
            outerHtml = outerHtml.replace(
              `name="${name}"`,
              `name="${_shuffleId}"`
            );
            radio.push(outerHtml);
            $(this).hide();
          });
      }
      let outPutHtml = generateHtmlForRandomizedArray(randomizeArray(radio));

      $(this).find(".form-radio").append(outPutHtml);
    });
}

function shuffleMultiChoice() {
  $("#formio .reorder.formio-component-selectboxes")
    .not(".reordered")
    .each(function () {
      $(this).addClass("reordered");
      let checkBoxArray = [];
      if ($(this).find(".form-check").length > 0) {
        $(this)
          .find(".form-check")
          .each(function () {
            let id = $(this)
              .find(".form-check-input")
              .prop("id")
              .replace(/&/g, "&amp;");
            let outerHtml = $(this).prop("outerHTML");
            outerHtml = outerHtml.replace(`id="${id}"`, `data-guid="${id}"`);
            outerHtml = outerHtml.replace(`for="${id}"`, `data-label="${id}"`);
            checkBoxArray.push(outerHtml);
            $(this).hide();
          });
      } else {
        $(this)
          .find(".form-check-inline")
          .each(function () {
            let id = $(this)
              .find(".form-check-input")
              .prop("id")
              .replace(/&/g, "&amp;");
            let outerHtml = $(this).prop("outerHTML");
            outerHtml = outerHtml.replace(`id="${id}"`, `data-guid="${id}"`);
            outerHtml = outerHtml.replace(`for="${id}"`, `data-label="${id}"`);
            checkBoxArray.push(outerHtml);
            $(this).hide();
          });
      }
      let outPutHtml = generateHtmlForRandomizedArray(
        randomizeArray(checkBoxArray)
      );

      $(this).find(".form-radio").append(outPutHtml);
    });
}

function randomizeArray(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

function generateHtmlForRandomizedArray(array) {
  let outputHtml = "";
  for (i = 0; i < array.length; i++) {
    outputHtml += array[i];
  }

  return outputHtml;
}

$(document).on("click", "[data-guid]", function () {
  let guid_current = cleanKey($(this).data("guid"));
  $(`[id="${guid_current}"]`).click();
});

function editGridLanguageChange(tag) {
  if (_languageContainer[tag]) {
    $(
      "#formio .formio-component-editgrid .editgrid-listgroup .list-group-header .row div"
    ).each(function () {
      const langVal = _languageContainer[tag][$(this).html()];
      if (langVal != null && langVal != "") {
        $(this).html(langVal);
      }
    });
  }
}

function hideSurveyAndShowMessage(message) {
  $(".survey-submission").append(`<div>${message}</div>`);
  $(".survey-form").remove();
  $(".survey-header").remove();
}

function enableWorkflowFunctionality() {
  if (_workflowDetails.isEnabled) {
    $("#loadWorkflowStatus").removeClass("hidden");
    translateWorkflowModules();
    return;
  }

  $("#workflow-modal").remove();
}

function translateWorkflowModules() {
  $(`#loadWorkflowStatus [data-translation="text-survey-status"]`)?.text(
    _translationData[_defaultLanguage.tag].surveyStatus
  );

  $(`[data-translation="btn-search"]`)?.text(
    _translationData[_defaultLanguage.tag].search
  );
  $(`[data-translation="btn-close"]`)?.text(
    _translationData[_defaultLanguage.tag].close
  );
}

function setPreviousSubmittedAswers() {}

function setSurveyTitle() {
  const title = _languageContainer[_defaultLanguage.tag]?.commonProps
    ?.surveyName
    ? _languageContainer[_defaultLanguage.tag]?.commonProps?.surveyName
    : _surveyTitle;

  $("#surveyName").html(title);
}

function setSurveyImages() {
  if (_fileData) {
    for (i = 0; i < _fileData.length; i++) {
      const fileDataKey = cleanKey(_fileData[i].key);
      const component = FormioUtils.getComponent(
        _builderHidden.instance.schema.components,
        _fileData[i].key
      );
      const classes = component?.customClass
        ? component.customClass.split(" ")
        : "";

      if (classes.indexOf("video") != -1) {
        var $target = $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find("div")
          .first();
        $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find(".fileSelector")
          .remove();
        var videoType =
          _fileData[i].link.indexOf(__appUrl) != -1
            ? _fileData[i].link.split(".")[
                _fileData[i].link.split(".").length - 1
              ]
            : "external";
        if (videoType == "external") {
          if (_fileData[i].link.indexOf("youtube.com") != -1) {
            var videoHtml = `<div class="av-content-iframe"><iframe src="${_fileData[
              i
            ].link.replace(
              "watch?v=",
              "embed/"
            )}" style="position: absolute; top: 0; left: 0; right: 0; width: 100%; height: 100%; max-width: 750px; max-height: 550px; border: none;">
                                      </iframe></div>`;
          } else {
            var videoHtml = `<video class="av-content" controls>
                                  <source src="${_fileData[i].link}">
                                  Your browser does not support the video
                              </video>`;
          }

          $target.html(videoHtml);
        } else {
          var videoHtml = `<video class="av-content"  controls>
                                  <source src="${_fileData[i].link}" type="video/${videoType}">
                                  Your browser does not support the video
                              </video>`;

          $target.html(videoHtml);
        }
      } else if (classes.indexOf("audio") != -1) {
        var $target = $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find("div")
          .first();
        $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find(".fileSelector")
          .remove();
        //var audioType = _fileData[i].link.indexOf(getApiUrl()) != -1 ? _fileData[i].link.split(".")[_fileData[i].link.split(".").length - 1] : "mp3";
        var audioHtml = `<audio controls>
                                  <source src="${_fileData[i].link}">
                                  Your browser does not support the audio.
                              </audio>`;

        $target.html(audioHtml);
      } else if (classes.includes("download")) {
        var $target = $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find("div")
          .first();
        $("#formio")
          .find(`.formio-component-${fileDataKey}`)
          .find(".fileSelector")
          .remove();
        //var fileType = _fileData[i].name.split(".")[_fileData[i].name.split(".").length - 1];
        var fileHtml = `<a href="${_fileData[i].link}" download><i class="subheader-icon fal fa-file-edit"></i><span>${_fileData[i].name}</span></a>`;
        $target.html(fileHtml);
      } else {
        if (_fileData[i].link) {
          var image = _surveyImages
            ? _surveyImages.components.filter(
                (x) => x.key == "formio-component-" + _fileData[i].key
              )
            : "";

          var $target = $("#formio")
            .find(`.formio-component-${fileDataKey}`)
            .find("div")
            .first();

          var imgHtml = `<div style="text-align:center">
                                  <span>
                                      <img style="${
                                        image != "" ? image[0]?.style : ""
                                      }" alt="${_fileData[i].name}" src="${
            _fileData[i].link
          }" ref="${_fileData[i].name}" />
                                  </span>
                              </div>`;

          $target.html(imgHtml);

          $(`#formio .formio-component-${fileDataKey} .fileSelector`).remove();
          $(
            `#formio .formio-component-${fileDataKey} label:first-child`
          ).remove();
          $target.css({ "justify-content": "center" });
          $target.closest("ul").css({ margin: "0" });
          $target.closest("ul").css({ padding: "0" });
        }
      }
    }
  }

  configureAudioRecorderComponent();
}

function configureAudioRecorderComponent(key) {
  // Audio recorder component configuration
  if (!key) {
    FormioUtils.eachComponent(
      _builderHidden.instance.schema.components,
      (component) => {
        if (
          component.customClass &&
          component.customClass.indexOf("voice") != -1
        ) {
          if (
            $(
              `#formio .formio-component-${cleanKey(
                component.key
              )} .fileSelector .record`
            ).length == 0
          ) {
            $(
              `#formio .formio-component-${cleanKey(
                component.key
              )} .fileSelector`
            ).html(`
              <i class="fa fa-cloud-upload"></i> ${
                _translationData[_defaultLanguage.tag].recordAudio
              },
              <a class="record" ref="fileBrowse" href="#" onclick="addRecoderForm('${
                component.key
              }')">${_translationData[_defaultLanguage.tag].record}</a>
            `);
          }
        }
      }
    );
  } else {
    $(`#formio .formio-component-${cleanKey(key)} .fileSelector`).html(`
      <i class="fa fa-cloud-upload"></i> ${
        _translationData[_defaultLanguage.tag].recordAudio
      },
      <a class="record" ref="fileBrowse" href="#" onclick="addRecoderForm('${key}')">${
      _translationData[_defaultLanguage.tag].record
    }</a>
    `);
  }
}

function setupAudioRecorderForHiddenWhenVisible() {
  const $target = $(`#formio .file.voice:not(.formio-hidden)`);
  $target.each(function () {
    if ($(this).find(".fileSelector .record").length == 0) {
      const key = $(this).find("label:first").prop("for").split("-").pop();
      configureAudioRecorderComponent(key);
    }
  });
}

function setupRecorderVariables(key) {
  // set up basic variables for app

  const record = document.querySelector(
    `#${cleanKey(key)}-recoder-modal .record`
  );
  const stop = document.querySelector(`#${cleanKey(key)}-recoder-modal .stop`);
  const soundClips = document.querySelector(
    `#${cleanKey(key)}-recoder-modal .sound-clips`
  );
  _recorderCanvas = document.querySelector(
    `#${cleanKey(key)}-recoder-modal .visualizer`
  );
  //_recorderMainSection = document.querySelector('#recoder-modal .main-controls');

  // disable stop button while not recording

  stop.disabled = true;

  // visualiser setup - create web audio api context and canvas

  _canvasCtx = _recorderCanvas.getContext("2d");

  //main block for doing the audio recording

  if (navigator.mediaDevices.getUserMedia) {
    const constraints = { audio: true };
    let chunks = [];

    let onSuccess = function (stream) {
      const mediaRecorder = new MediaRecorder(stream);

      //visualize(stream);

      record.onclick = function () {
        mediaRecorder.start();
        console.log(mediaRecorder.state);
        console.log("recorder started");
        record.style.background = "red";

        stop.disabled = false;
        record.disabled = true;
      };

      stop.onclick = function () {
        mediaRecorder.stop();
        console.log(mediaRecorder.state);
        console.log("recorder stopped");
        record.style.background = "";
        record.style.color = "";
        // mediaRecorder.requestData();

        stop.disabled = true;
        record.disabled = false;
      };

      mediaRecorder.onstop = function (e) {
        console.log("data available after MediaRecorder.stop() called.");

        const clipName = prompt(
          _translationData[_defaultLanguage.tag]["recordNameLabel"],
          _translationData[_defaultLanguage.tag]["recordName"]
        );

        const clipContainer = document.createElement("article");
        _recordingClipLabel = document.createElement("p");
        _recordingClipLabel.dataset.translation = "txt_recordname";
        const audio = document.createElement("audio");
        const deleteButton = document.createElement("button");

        clipContainer.className = "clip audio-clip-section";
        audio.setAttribute("controls", "");
        deleteButton.textContent = "Delete";
        deleteButton.className = "delete btn btn-warning";
        deleteButton.dataset.translation = "btn_delete";

        if (clipName === null) {
          _recordingClipLabel.textContent =
            _translationData[_defaultLanguage.tag].recordName;
        } else {
          _recordingClipLabel.textContent = clipName;
        }

        clipContainer.appendChild(audio);
        clipContainer.appendChild(_recordingClipLabel);
        clipContainer.appendChild(deleteButton);
        soundClips.appendChild(clipContainer);

        audio.controls = true;
        _recordingBlob = new Blob(chunks, { type: "audio/mp3; codecs=opus" });
        chunks = [];
        const audioURL = window.URL.createObjectURL(_recordingBlob);
        audio.src = audioURL;
        console.log("recorder stopped");

        deleteButton.onclick = function (e) {
          let evtTgt = e.target;
          evtTgt.parentNode.parentNode.removeChild(evtTgt.parentNode);
        };

        _recordingClipLabel.onclick = function () {
          const existingName = _recordingClipLabel.textContent;
          const newClipName = prompt(
            _translationData[_defaultLang.tag].enterNameSoundClip
          );
          if (newClipName === null) {
            _recordingClipLabel.textContent = existingName;
          } else {
            _recordingClipLabel.textContent = newClipName;
          }
        };

        //translateStatic(_currentLang, _directionContainer[_currentLang]);
      };

      mediaRecorder.ondataavailable = function (e) {
        chunks.push(e.data);
      };
    };

    let onError = function (err) {
      console.log("The following error occured: " + err);
    };

    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  } else {
    console.log("getUserMedia not supported on your browser!");
  }
}

function saveRecorderData(key) {
  let reader = new FileReader();
  reader.readAsDataURL(_recordingBlob);
  reader.onloadend = function () {
    const base64String = reader.result;

    const recordingIndex = _recordingData.findIndex((x) => x.key === key);
    if (recordingIndex != -1) {
      _recordingData[recordingIndex].data = base64String;
    } else {
      _recordingData.push({
        key,
        data: base64String,
        name: _recordingClipLabel.textContent + ".mp3",
      });
    }
    closeRecorderModal(key);
    updateFileUploadForRecording(key);
  };
}

function updateFileUploadForRecording(key) {
  const recordingData = _recordingData.filter((x) => x.key === key)[0];
  _globalForm.getComponent(key).setValue([
    {
      name: recordingData.name,
      originalName: recordingData.name,
      storage: "base64",
      type: "application/mp3",
      url: recordingData.data,
    },
  ]);
}

function closeRecorderModal(key) {
  $(`#${cleanKey(key)}-recoder-modal`).modal("hide");
  setTimeout(() => {
    $(`#${cleanKey(key)}-recoder-modal`).remove();
  }, 300);

  _audioCtx = null;
  _canvasCtx = null;
  _recorderMainSection = null;
  _recorderCanvas = null;
  _recordingBlob = null;
  _recordingClipLabel = null;
}

function enableOTP() {
  for (i = 0; i < _otpDetails.length; i++) {
    if (
      $(`#formio .formio-component-${cleanKey(_otpDetails[i].key)}:visible`)
        .length > 0 &&
      _otpDetails[i].isEnabled
    ) {
      //Genarate html for button and OTP
      const otpDetailsKey = cleanKey(_otpDetails[i].key);
      if (
        $(
          `#formio .formio-component-${otpDetailsKey} [name="data[${otpDetailsKey}]"]`
        )
          .parent()
          .find(".generate-otp").length == 0
      ) {
        $(
          `#formio .formio-component-${otpDetailsKey} [name="data[${otpDetailsKey}]"]`
        )
          .parent()
          .append(
            `<button data-languagetranslation="generateOtp" class="btn btn-success mt-2 generate-otp ${
              _otpDetails[i].key
            }-btn" onclick="generateOTP(this,'${_otpDetails[i].key}')">${
              _translationData[_defaultLanguage.tag].generateOtp
            }</button><label class="${_otpDetails[i].key}-label"></label>`
          );
        if ($(`#formio [name="data[submit]"]:visible`).length > 0) {
          //Disabled submit and next button
          $(`#formio [name="data[submit]"]:visible`).prop("disabled", true);
          //setNextBtn();
        }
      }
    }
  }
}

function setPageBackground() {
  $(".page-content-wrapper").attr(
    "style",
    `background-color: ${_pageBackground.pageColor}`
  );
  $(".subheader-title").css({ color: _pageBackground.pageTextColor });
  $(".submssion-message").css({ color: _pageBackground.pageTextColor });
  $(".subheader-icon").attr(
    "style",
    `color: ${_pageBackground.pageTextColor}!important`
  );
}

function addRanking() {
  if ($("#formio .rank .form-check label").length > 0) {
    let keys = [];
    FormioUtils.eachComponent(
      _builderHidden.instance.schema.components,
      (component) => {
        if (
          component.type == "selectboxes" &&
          component.customClass &&
          component.customClass.split(" ").indexOf("rank") != -1
        ) {
          keys.push({
            key: component.key,
            max:
              component.validate && component.validate.maxSelectedCount
                ? component.validate.maxSelectedCount
                : -1,
            min:
              component.validate && component.validate.minSelectedCount
                ? component.validate.minSelectedCount
                : -1,
          });
        }
      }
    );
    $("#formio .rank .form-check label").each(function () {
      let max = -1;
      let minValidation;
      for (i = 0; i < keys.length; i++) {
        if (
          $(this)
            .closest(".rank")
            .attr("class")
            .split(" ")
            .indexOf(`formio-component-${keys[i].key}`) != -1
        ) {
          max = keys[i].max;
          minValidation = keys[i].min;
          if (max == -1) {
            max = $(this)
              .closest(".rank")
              .find(".form-check input[type=checkbox]").length;
          }
          break;
        }
      }
      if ($(this).find("input[type=number]").length == 0) {
        $(this).append(
          `<input type="number" min="1" max="${max}" data-minvalidation="${minValidation}" disabled class="rank-choice" data-choiceval="${$(
            this
          )
            .find('input[type="checkbox"]')
            .val()}" onchange="validateRankingOnChange(this)" />`
        );
      }
    });
  }
}

function addLinkedPictures() {
  for (i = 0; i < _linkedPictures.length; i++) {
    $(
      `#formio .formio-component-${cleanKey(
        _linkedPictures[i].key
      )} .form-check-label [ref="input"]`
    ).each(function () {
      let value = $(this).val();
      let pic = _linkedPictures[i].data.filter(
        (item) => item.option == value
      )[0].picture
        ? _linkedPictures[i].data.filter((item) => item.option == value)[0]
            .picture
        : "";
      if (pic && $(this).parent().find("span").length > 0) {
        $(this)
          .parent()
          .find("span")
          .after(
            `<img class="linked-picture" title="${value}" src="${pic}" />`
          );
        $(this).parent().find("span").remove();
      }
    });
  }
}

function linkManipulation() {
  $("#formio .formio-component-content a").each(function () {
    $(this).prop("target", "_blank");
  });
}

function initializeSubmissionLogos() {
  $("#formio .submission-logo").each(function () {
    _submissionLogos.push($(this).prop("outerHTML").replace("hide", ""));
    $(this).hide();
  });
}

function validateUniquenessNext() {
  let isValid = true;
  let validationElements = {};
  let unAnsweredElements = [];
  for (i = 0; i < _surveyValidation.length; i++) {
    const surveyValidationKey = cleanKey(_surveyValidation[i].key);
    if (
      $(`.formio-component-${surveyValidationKey}:visible`).length > 0 &&
      !validationElements[_surveyValidation[i].key]
    ) {
      const component = FormioUtils.getComponent(
        _builderHidden.instance.schema.components,
        _surveyValidation[i].key
      );

      validationElements[_surveyValidation[i].key] = {
        fieldName: component.label,
        validation: component?.validate?.custom,
        answer: $(`#formio [name="data[${surveyValidationKey}]"]`).val(),
      };
    }
  }

  let pageElementErrorsCount = 1;

  for (key in validationElements) {
    if (validationElements[key].answer == "") {
      unAnsweredElements.push({ ...validationElements[key], key });
    }

    const validationCondition = validationElements[key].validation
      ?.split("valid = ")[1]
      ?.split("? true")[0]
      ?.replace(/input/g, `'${_globalForm.data[key]}'`)
      ?.split("||");

    if (!validationCondition) {
      pageElementErrorsCount--;
    }

    for (let j = 0; j < validationCondition?.length; j++) {
      let cond = validationCondition[j].trim();
      cond = bracketCountCondition(cond);
      if (new Function("return " + cond)()) {
        pageElementErrorsCount--;
        break;
      }
    }

    if (pageElementErrorsCount == 1) {
      isValid = false;
      break;
    }
  }

  if (pageElementErrorsCount > 0 && validationElements.length > 0) {
    return isValid;
  }

  if (unAnsweredElements.length > 0) {
    showError(`${unAnsweredElements[0].fieldName} is invalid.`);
    return false;
  } else if (Object.keys(validationElements).length > 0) {
    let data = {
      surveyId: _surveyId,
      workflowUniqueKey: _workflowUniqueKey,
      questionAnswers: [],
    };

    for (key in validationElements) {
      data.questionAnswers.push({
        key,
        question: validationElements[key].fieldName,
        answer: validationElements[key].answer,
      });
    }

    $.ajax({
      url: `${__appUrl}/api/submissions/validate-uniqueness`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        _uniquenessValidatedComponents = data.questionAnswers;

        isValid = response;
      },
    });
  }

  return isValid;
}

function validateUniqueness(submission) {
  var isValid = true;
  var validationElements = {};

  for (i = 0; i < _surveyValidation.length; i++) {
    if (
      $(`.formio-component-${cleanKey(_surveyValidation[i].key)}:visible`)
        .length > 0 &&
      !validationElements[_surveyValidation[i].key] &&
      _uniquenessValidatedComponents.findIndex(
        (x) =>
          x.key === _surveyValidation[i].key &&
          x.answer === submission.data[_surveyValidation[i].key]
      ) === -1
    ) {
      const component = FormioUtils.getComponent(
        _builderHidden.instance.schema.components,
        _surveyValidation[i].key
      );

      validationElements[_surveyValidation[i].key] = {
        fieldName: component.label,
        validation: component?.validate?.custom,
        answer: submission.data[_surveyValidation[i].key],
      };
    }
  }

  if (Object.keys(validationElements).length > 0) {
    let data = {
      surveyId: _surveyId,
      workflowUniqueKey: _workflowUniqueKey,
      questionAnswers: [],
    };

    for (key in validationElements) {
      data.questionAnswers.push({
        question: validationElements[key].fieldName,
        answer: validationElements[key].answer,
      });
    }

    $.ajax({
      url: `${__appUrl}/api/submissions/validate-uniqueness`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        isValid = response;
      },
    });
  }

  return isValid;
}

function validateUniqueSubmission() {
  let validationElements = [];

  if (!_uniqueQuestions || _uniqueQuestions.length === 0) {
    return true;
  }

  for (let i = 0; i < _uniqueQuestions.length; i++) {
    const answer = _globalForm
      .getComponent(_uniqueQuestions[i])
      ?.getValue(_uniqueQuestions[i]);
    if (!answer) {
      continue;
    }

    let existingValidation = _uniqueQuestionsValidationResults.filter(
      (x) => x.key === _uniqueQuestions[i]
    );
    if (existingValidation.length > 0) {
      if (
        existingValidation[0].answer === answer &&
        existingValidation[0].isValid
      ) {
        continue;
      }
    }

    _uniqueQuestionsValidationResults.push({
      key: _uniqueQuestions[i],
      answer: answer,
      isValid: false,
    });

    validationElements.push({
      key: _uniqueQuestions[i],
      answer: answer,
    });
  }

  if (validationElements.length === 0) {
    return true;
  }

  let data = {
    surveyId: _surveyId,
    workflowUniqueKey: _workflowUniqueKey,
    keyAnswers: validationElements,
  };

  let isValid = true;
  $.ajax({
    url: `${__appUrl}/api/submissions/validate-unique-submission`,
    async: false,
    type: "POST",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify(data),
    success: function (response) {
      isValid = response;
    },
  });

  if (isValid) {
    for (let i = 0; i < _uniqueQuestionsValidationResults.length; i++) {
      _uniqueQuestionsValidationResults[i].isValid = true;
    }
  }

  return isValid;
}

function bracketCountCondition(cond) {
  let bracketCount = 0;
  for (z = 0; z < cond.length; z++) {
    if (cond[z] == "(") {
      bracketCount++;
    } else if (cond[z] == ")") {
      bracketCount--;
    }
  }

  if (bracketCount > 0) {
    for (z = 0; z < bracketCount; z++) {
      cond = cond.replace("(", "");
    }
  } else if (bracketCount < 0) {
    lastIndex = -1;
    for (z = 0; z > bracketCount; z--) {
      lastIndex = cond.lastIndexOf(")");
      cond = cond.replaceAt(lastIndex, "");
    }
  }

  return cond;
}

function validateCategoryLimit() {
  let isValid = true;
  if (_categoryLimit && _categoryLimit.length > 0) {
    const data = {
      surveyId: _surveyId,
      questionAnswers: _categoryLimit.reduce((acc, x) => {
        if (_globalForm.getComponent(x.key)) {
          acc.push({
            key: x.key,
            primaryQuestion: x.data[0].primaryQuestion,
            answer: _globalForm.getComponent(x.key).getValue(),
          });
        }
        return acc;
      }, []),
    };

    $.ajax({
      url: `${__appUrl}/api/submissions/validate-category-limit`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        _categoryLimitErrors = response.errorMessages;
        if (_categoryLimitErrors && _categoryLimitErrors.length > 0) {
          isValid = false;
        }
      },
    });
  }

  return isValid;
}

function validateRankingOnPageChange() {
  let errorMessage = [];
  if ($("#formio .rank:visible").length > 0) {
    $("#formio .rank:visible").each(function () {
      let isValid = true;
      let numVals = [];
      $(this)
        .find(".form-check label input[type=checkbox]:checked:visible")
        .each(function () {
          if ($(this).parent().find("input[type=number]").val() == "") {
            isValid = false;
            $(this).parent().find("input[type=number]").addClass("error");
          }
          if (
            numVals.indexOf(
              $(this).parent().find("input[type=number]").val()
            ) != -1 &&
            $(this).parent().find("input[type=number]").val() != ""
          ) {
            isValid = false;
            $(this).parent().find("input[type=number]").addClass("error");
          } else {
            numVals.push($(this).parent().find("input[type=number]").val());
          }
        });

      if (isValid) {
        isValid = new Set(numVals).size === numVals.length;
      }

      if (!isValid) {
        errorMessage.push($(this).attr("class"));
      }
    });
  }

  if (!errorMessage.length == 0) {
    showError(_translationData[_defaultLanguage.tag].duplicateRanking);
  }

  return errorMessage.length == 0;
}

function validateRanking() {
  let isValid = true;
  if ($("#formio .rank").length > 0) {
    $("#formio .rank").each(function () {
      let numVals = [];
      $(this)
        .find(".form-check label input[type=checkbox]:checked:visible")
        .each(function () {
          if ($(this).parent().find("input[type=number]").val() == "") {
            isValid = false;
            $(this).parent().find("input[type=number]").addClass("error");
          }
          if (
            numVals.indexOf(
              $(this).parent().find("input[type=number]").val()
            ) != -1 &&
            $(this).parent().find("input[type=number]").val() != ""
          ) {
            isValid = false;
            $(this).parent().find("input[type=number]").addClass("error");
          } else {
            numVals.push($(this).parent().find("input[type=number]").val());
          }
        });

      if (isValid) {
        isValid = new Set(numVals).size === numVals.length;
      }
    });
  }
  return isValid;
}

function validateRankingOnChange(e) {
  const minValidation = parseInt($(e).data("minvalidation"));
  const max = minValidation !== -1 ? minValidation : parseInt($(e).prop("max"));
  if ($(e).val() > max || $(e).val() <= 0) {
    $(e).val("");
    $(e).addClass("is-invalid").addClass("was-validated");
  } else {
    $(e).removeClass("is-invalid").removeClass("was-validated");
  }
}

function addNoneOfAbove() {
  for (let i = 0; i < _noneOfAboveDetails.length; i++) {
    const noneOfAboveKey = cleanKey(_noneOfAboveDetails[i].key);
    if ($(`#formio .formio-component-${noneOfAboveKey}`).length > 0) {
      if (_noneOfAboveDetails[i].type == "all") {
        $(
          `#formio .formio-component-${noneOfAboveKey} .form-radio .form-check:last-child input`
        ).addClass("all-of-above");
        $(
          `#formio .formio-component-${noneOfAboveKey} .form-radio .form-check:last-child input`
        ).addClass(`${_noneOfAboveDetails[i].key}-all-of-above`);
        continue;
      }
      $(
        `#formio .formio-component-${noneOfAboveKey} .form-radio .form-check:last-child input`
      ).addClass("none-of-above");
      $(
        `#formio .formio-component-${noneOfAboveKey} .form-radio .form-check:last-child input`
      ).addClass(`${_noneOfAboveDetails[i].key}-none-of-above`);
    }
  }
}

function getCategoryLimitExceed() {
  var isShouldHideWhenLimitExceedsEnabled =
    _categoryLimit.filter((x) => x.shouldHideWhenLimitExceeds).length > 0;
  if (
    isShouldHideWhenLimitExceedsEnabled &&
    _categoryLimitExceeded.length == 0
  ) {
    $.ajax({
      url: `${__appUrl}/api/submissions/category-limit-exceeded/${_surveyId}`,
      async: false,
      type: "GET",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      success: function (response) {
        _categoryLimitExceeded = response;
        hideChoiceWhoseLimitHasExceeded();
      },
    });
  }
}

function hideChoiceWhoseLimitHasExceeded() {
  if (_categoryLimitExceeded.length > 0) {
    var currentPrimaryQuestion = "";
    var currentComponent = "";
    for (let i = 0; i < _categoryLimitExceeded.length; i++) {
      if (currentPrimaryQuestion != _categoryLimitExceeded[i].primaryQuestion) {
        currentPrimaryQuestion = _categoryLimitExceeded[i].primaryQuestion;
        const currentKey = _categoryLimitExceeded[i].key;
        currentComponent = FormioUtils.findComponents(
          _builderHidden.instance.schema.components,
          {
            key: currentKey,
          }
        );
      }

      currentComponent = currentComponent.filter(
        (x) =>
          x.type === "radio" || x.type === "selectboxes" || x.type === "select"
      );

      if (
        currentComponent[0].type === "radio" ||
        currentComponent[0].type === "selectboxes"
      ) {
        var $target = $(
          `#formio .formio-component-${cleanKey(
            currentComponent[0].key
          )} .radio.form-check label[for$="--${
            _categoryLimitExceeded[i].answer
          }"]`
        ).parent();
        $target.remove();
      } else {
        let component = _globalForm.getComponent(currentComponent[0].key);
        component.component.data.values =
          component.component.data.values.filter(
            (x) => x.value !== _categoryLimitExceeded[i].answer
          );
        component.redraw();
        setTimeout(() => {
          setCustomCss(component.key);
        }, 200);
      }
    }
  }
}

function setFileType(key) {
  $($(`#formio .formio-component-${cleanKey(key)}`).find("img")).each(
    function () {
      var name = $(this).attr("alt");
      $(this)
        .parent()
        .prepend(
          `<i class="fa fa-file"><i><span class="file-upload-name">${name}</span>`
        );
      $(this).css({ display: "none" });
    }
  );
}

function setLinkedDataFields(key, value, e) {
  let linkedDataVals = _linkedData.filter(
    (item) => item.key === key && item.type !== "survey"
  );
  if (linkedDataVals.length > 0) {
    let data = linkedDataVals[0].data.filter((item) => item[key] == value);
    if (data.length > 0) {
      for (item in data[0]) {
        if (item !== key) {
          if (_globalForm.getComponent(item).type === "datetime") {
            _globalForm.getComponent(item).setValue(new Date(data[0][item]));
          } else {
            _globalForm.getComponent(item).setValue(data[0][item]);
          }
        }
      }
      $(`#formio [name="data[${key}]"]`).blur();
    }
  }
}

function disableAndClear(key, value) {
  const cleanedKey = cleanKey(key);

  if (
    $(`.formio-component-${cleanedKey}`)
      .attr("class")
      .split(" ")
      .indexOf("rank") != -1
  ) {
    $(
      `.formio-component-${cleanedKey} .form-check label input[type=number]`
    ).each(function () {
      if (value[$(this).data("choiceval")] == false) {
        $(this).val("");
        $(this).attr("disabled", "disabled");
      } else {
        $(this).removeAttr("disabled");
        $(this).focus();
      }
    });
  }
  const searchedComponents = FormioUtils.searchComponents(
    _builderHidden.instance.schema.components,
    { key: key }
  );
  let maxCount =
    searchedComponents[0].validate &&
    searchedComponents[0].validate.maxSelectedCount
      ? searchedComponents[0].validate.maxSelectedCount
      : -1;
  if (maxCount != -1) {
    let val = _globalForm.getComponent(key).getValue();
    selectedCount = 0;
    for (item in val) {
      if (val[item]) {
        selectedCount++;
      }
    }
    if (selectedCount < maxCount) {
      $(
        `.formio-component-${cleanedKey} .form-check label input[type=checkbox]`
      ).removeAttr("disabled");
    } else if (selectedCount == maxCount) {
      $(
        `.formio-component-${cleanedKey} .form-check label input[type=checkbox]`
      ).each(function () {
        if (!$(this).prop("checked")) {
          $(this).attr("disabled", true);
        }
      });
    }
  }
}

function validateRequiredForLinkedQuestion() {
  let isValid = true;
  _requiredValidationErrors = [];
  let currentQuestionSet = _linkedQuestions.filter(
    (q) => q.isRequired && !q.isMultidata
  );
  for (let i = 0; i < currentQuestionSet.length; i++) {
    const currentQuestionSetKey = cleanKey(currentQuestionSet[i].key);

    if (
      $(`.formio-component-${currentQuestionSetKey}:visible`).length > 0 &&
      currentQuestionSet[i].isRequired
    ) {
      if (
        currentQuestionSet[i].qType == "Dropdown" &&
        !$(`#${currentQuestionSetKey}`).val()
      ) {
        isValid = false;
        _requiredValidationErrors.push(
          `${currentQuestionSet[i].label} is required.`
        );
      } else if (
        currentQuestionSet[i].qType == "Single Choice" ||
        currentQuestionSet[i].qType == "Multiple Choice"
      ) {
        if ($(`[name="${currentQuestionSetKey}"]:checked`).length === 0) {
          isValid = false;
          _requiredValidationErrors.push(
            `${currentQuestionSet[i].label} is required.`
          );
        }
      }
    }
  }
  if (isValid) {
    let currentMultidataQuestionSet = _linkedQuestions.filter(
      (q) => q.isRequired && q.isMultidata && q.multidataQuestion
    );
    isValid = validateRequiredForLinkedQuestionMultidata(
      currentMultidataQuestionSet
    );
  }

  return isValid;
}

function validateRequiredForLinkedQuestionMultidata(multidataQuestionSet) {
  let isValid = true;
  for (let i = 0; i < multidataQuestionSet.length; i++) {
    let values = _globalForm
      .getComponent(multidataQuestionSet[i].multidataQuestion)
      .getValue();

    if (values.filter((q) => !q[multidataQuestionSet[i].key]).length > 0) {
      isValid = false;
      _requiredValidationErrors.push(
        `${multidataQuestionSet[i].label} is required.`
      );
      break;
    }
  }
  return isValid;
}

function mobileAndTabletcheck() {
  var isMobileOrTablet = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return isMobileOrTablet;
}

function browserDetector() {
  // Opera 8.0+
  var isOpera =
    (!!window.opr && !!opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(" OPR/") >= 0;

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== "undefined";

  // Safari 3.0+ "[object HTMLElementConstructor]"
  var isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(
      !window["safari"] ||
        (typeof safari !== "undefined" && safari.pushNotification)
    );

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1 - 79
  var isChrome =
    !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  // Edge (based on chromium) detection
  var isEdgeChromium = isChrome && navigator.userAgent.indexOf("Edg") != -1;

  // Blink engine detection
  //var isBlink = (isChrome || isOpera) && !!window.CSS;

  return isOpera
    ? "Opera"
    : isFirefox
    ? "Firefox"
    : isSafari
    ? "Safari"
    : isIE
    ? "InternetExplorer"
    : isEdge
    ? "Edge"
    : isChrome
    ? "Chrome"
    : isEdgeChromium
    ? "EdgeChromium"
    : "Others";
}

function getWorkflowDetails() {
  let isResubmission = _workflowUniqueKey ? true : false;
  const uniqueKey = _workflowUniqueKey
    ? _workflowUniqueKey
    : $.uuid().replace(/-/g, "");

  _workflowUniqueKey = uniqueKey;
  const lang = _defaultLanguage.tag;
  let submissionMessageFormSubmit =
    _languageContainer[lang] &&
    _languageContainer[lang]?.commonProps?.surveyMessage
      ? _languageContainer[lang].commonProps.surveyMessage
      : _submissionMessage;

  if (_workflowDetails?.isEnabled) {
    if (
      submissionMessageFormSubmit.toLowerCase().indexOf("{uniquekey}") !== -1
    ) {
      submissionMessageFormSubmit.replace(/{uniquekey}/g, uniqueKey);
    } else {
      submissionMessageFormSubmit += _translationData[
        _defaultLanguage.tag
      ].uniqueKeyIs.replace("{UNIQUEKEY}", uniqueKey);
    }
  }

  let workflowDetails = {
    workflowUniqueKey: uniqueKey,
    isReSubmission: isResubmission,
  };

  return workflowDetails;
}

function printSurveyBeforeSubmission() {
  $(".survey-print-container").remove();

  let source = document.createElement("div");
  source.className = "survey-print-container d-flex flex-column p-5 mt-4 w-100";
  $("body").append(source);
  $(".survey-print-container").attr("style", "width: 980px");
  $(".survey-print-container").append(
    `<div class="fs-700 fw-700 d-flex mb-5 justify-content-center">${_surveyTitle}</div>`
  );

  const componentsTobeIgnored = [
    "panel",
    "column",
    "table",
    "tabs",
    "button",
    "editgrid",
  ];
  FormioUtils.eachComponent(
    _builderHidden.instance.schema.components,
    (component) => {
      if (
        componentsTobeIgnored.includes(component.type) ||
        component.type == undefined
      ) {
        return;
      }

      let element = `<div class="w-100 d-flex flex-column mb-4 s16 fbold">`;

      if (component.type === "selectboxes") {
        element += `<label>${component.label}</label>`;
        for (let i = 0; i < component.values.length; i++) {
          element += `<div><input type='checkbox' value='${component.values[i].label}' class='m-1' readonly /><label>${component.values[i].label}</label></div>`;
        }
      } else if (component.type === "survey") {
        element += `<label>${component.label}</label>`;
        element += '<table class="table table-bordered"><tr>';
        for (let i = 0; i < component.values.length; i++) {
          element += `<th>${component.values[i].label}</th>`;
        }
        element += "</tr>";

        for (let i = 0; i < component.questions.length; i++) {
          element += "<tr>";
          for (let j = 0; j < component.values.length; j++) {
            element += `<td><input type='radio' readonly /></td>`;
          }
          element += "</tr>";
        }
        element += "</table>";
      } else if (component.type === "file") {
        if (
          !(
            component.customClass?.includes("file") ||
            component.customClass?.includes("audio") ||
            component.customClass?.includes("video") ||
            component.customClass?.includes("record") ||
            component.customClass?.includes("voice") ||
            component.customClass?.includes("download")
          )
        ) {
          const img = $(`.formio-component-${component.type}`)
            .find("img")
            .parent()
            .html();
          let imgElement = $(`${img}`);
          imgElement.addClass("m-auto");

          element += imgElement.prop("outerHTML");
        }
      } else if (component.type === "editgrid") {
      } else if (component.type === "custom") {
        element += `<label>${component.label}</label>`;
        const linkedQuestion = _linkedQuestions.filter(
          (x) => x.key === component.key
        );
        if (linkedQuestion && linkedQuestion.length === 1) {
          if (linkedQuestion[0].qType === "Multiple Choice") {
            for (key in linkedQuestion[0].value) {
              for (let i = 0; i < linkedQuestion[0].value[key].length; i++) {
                element += `<div><input type='checkbox' value='${key} - ${linkedQuestion[0].value[key][i]}' class='m-1' readonly /><label>${key} - ${linkedQuestion[0].value[key][i]}</label></div>`;
              }
            }
          } else {
            for (key in linkedQuestion[0].value) {
              for (let i = 0; i < linkedQuestion[0].value[key].length; i++) {
                element += `<div><input type='radio' value='${key} - ${linkedQuestion[0].value[key][i]}' class='m-1' readonly /><label>${key} - ${linkedQuestion[0].value[key][i]}</label></div>`;
              }
            }
          }
        }
      } else if (component.type === "select") {
        element += `<label>${component.label}</label>`;
        for (let i = 0; i < component.data.values.length; i++) {
          element += `<div><input type='radio' value='${component.data.values[i].label}' class='m-1' readonly /><label>${component.data.values[i].label}</label></div>`;
        }
      } else if (component.type === "radio") {
        element += `<label>${component.label}</label>`;
        for (let i = 0; i < component.values.length; i++) {
          element += `<div><input type='radio' value='${component.values[i].label}' class='m-1' readonly /><label>${component.values[i].label}</label></div>`;
        }
      } else if (component.type === "content") {
        element += component.html;
      } else if (component.type === "textarea") {
        element += `<label>${component.label}</label>`;
        element += `<textarea rows='5' class="form-control" readonly></textarea>`;
      } else {
        element += `<label>${component.label}</label>`;
        element += `<input type='text' class="form-control" readonly />`;
      }

      element += "</div>";

      $(".survey-print-container").append(element);
    },
    true
  );

  $(".survey-print-container").prop("lang", _defaultLanguage.tag);

  $(".survey-print-container").append(`
          <div class="w-100 d-flex justify-content-between mb-4 mt-4 s16 fbold">
              <div style="direction: ltr">
                  ${new Date().toLocaleString()}
              </div>
              <div>
                  Data Mining - Estebyan
              </div>
          </div>`);

  $(".survey-print-container").append(
    `<div><button class="btn btn-primary btn-sm" onclick="closePrintSurvey()">${
      _translationData[_defaultLanguage.tag].back
    }</button></div>`
  );
  $(".main-container").hide();
  $(".site-footer").addClass("hidden");
  window.scrollTo(0, document.body.scrollHeight);
  setTimeout(() => {
    window.print();
  }, 500);
}

function printSurveyAfterSubmission() {
  $(".survey-print-container").remove();

  let source = document.createElement("div");
  source.className = "survey-print-container d-flex flex-column p-5 mt-4 w-100";
  $("body").append(source);
  $(".survey-print-container").attr("style", "width: 980px");
  $(".survey-print-container").append(
    `<div class="fs-700 fw-700 d-flex mb-5 justify-content-center">${_surveyTitle}</div>`
  );

  const componentsTobeIgnored = [
    "panel",
    "column",
    "table",
    "tabs",
    "button",
    "editgrid",
  ];
  FormioUtils.eachComponent(
    _builderHidden.instance.schema.components,
    (component) => {
      if (
        componentsTobeIgnored.includes(component.type) ||
        component.type == undefined
      ) {
        return;
      }

      let element = `<div class="w-100 d-flex flex-column mb-4 s16 fbold">`;

      if (component.type === "file") {
        if (
          !(
            component.customClass?.includes("file") ||
            component.customClass?.includes("audio") ||
            component.customClass?.includes("video") ||
            component.customClass?.includes("record") ||
            component.customClass?.includes("voice") ||
            component.customClass?.includes("download")
          )
        ) {
          const img = $(`.formio-component-${component.type}`)
            .find("img")
            .parent()
            .html();
          let imgElement = $(`${img}`);
          imgElement.addClass("m-auto");

          element += imgElement.prop("outerHTML");
        }
      } else if (component.type === "content") {
        element += component.html;
      } else if (component.type === "select") {
        element += `<label>${component.label}</label>`;
        const answer = _globalForm.getComponent(component.key).getValue();
        const questions = component.data.values;
        const answerLabel =
          questions.filter((x) => x.value === answer)[0]?.label ?? "";
        element += `<p class="bg-print">${answerLabel}</p>`;
      } else if (component.type === "radio") {
        element += `<label>${component.label}</label>`;
        const answer = _globalForm.getComponent(component.key).getValue();
        const questions = component.values;
        const answerLabel =
          questions.filter((x) => x.value === answer)[0]?.label ?? "";
        element += `<p class="bg-print">${answerLabel}</p>`;
      } else if (component.type === "selectboxes") {
        element += `<label>${component.label}</label><div>`;
        const answers = _globalForm.getComponent(component.key).getValue();
        const questions = component.values;
        for (key in answers) {
          const answerLabel =
            questions.filter((x) => x.value === key)[0]?.label ?? "";
          if (answers[key]) {
            element += `<p class="bg-print">${answerLabel}</p>`;
          }
        }
        element += "</div>";
      } else if (component.type === "survey") {
        element += `<label>${component.label}</label><div>`;
        const answers = _globalForm.getComponent(component.key).getValue();
        const questions = component.questions;
        for (key in answers) {
          const questionLabel =
            questions.filter((x) => x.value === key)[0]?.label ?? "";
          element += `<p class="bg-print">${questionLabel}-${answers[key]}</p>`;
        }
      } else if (component.type === "datetime") {
        const answer = _globalForm.getComponent(component.key).getValue();
        const formatedAnswer = formatDateTimeForSurveyForm(
          answer,
          component.format
        );
        element += `<label>${component.label}</label>`;
        element += `<p class="bg-print">${formatedAnswer}</p>`;
      } else {
        element += `<label>${component.label}</label>`;
        element += `<p class="bg-print">${_globalForm
          .getComponent(component.key)
          .getValue()}</p>`;
      }

      element += "</div>";

      $(".survey-print-container").append(element);
    },
    true
  );

  $(".survey-print-container").append(`
          <div class="w-100 d-flex justify-content-between mb-4 mt-4 s16 fbold">
              <div style="direction: ltr">
                  ${new Date().toLocaleString()}
              </div>
              <div>
                  Data Mining - Estebyan
              </div>
          </div>`);

  $(".survey-print-container").prop("lang", _defaultLanguage.tag);
  $(".survey-print-container").append(
    `<div><button class="btn btn-primary btn-sm" onclick="closePrintSurvey()">${
      _translationData[_defaultLanguage.tag].back
    }</button></div>`
  );
  $(".main-container").hide();
  $(".site-footer").addClass("hidden");
  window.scrollTo(0, document.body.scrollHeight);
  setTimeout(() => {
    window.print();
  }, 500);
}

function closePrintSurvey() {
  $(".main-container").show();
  $(".survey-print-container").remove();
  $(".site-footer").removeClass("hidden");
}

function printCertificate() {
  if (_certificate && _certificate.template) {
    $(".site-header").hide();
    $(".site-footer").hide();
    $(".survey-submission").hide();

    $(".certificate-module").html($.parseHTML(_certificate.template));
    $(".certificate-module .certificate-img-container span").remove();
    $(".certificate-module [contenteditable]").removeAttr("contenteditable");
    $(".certificate-module .survey-question").each(function () {
      const key = $(this).find("select .selected").val();
      $(this).html(_globalForm.getComponent(key).getValue());
    });

    const isImg = certificateConfiguration(_certificate.name);

    if (!isImg) {
      const doc = new jspdf.jsPDF(
        "l",
        "px",
        _certificateConfig[_certificate.name].size,
        true
      );
      const element = document.querySelector(".main-container");
      doc.html(element, {
        callback: function (doc) {
          doc.save("certificate.pdf");
        },
        x: 15,
        y: 15,
      });
      $(".certificate-module").html("");
    } else {
      $(".submssion-message").remove();
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }
}

function certificateConfiguration(certificate) {
  if (
    certificate == "certificate2.html" ||
    certificate == "certificate3.html" ||
    certificate == "certificate4.html"
  ) {
    $(".certificate-module .main-container").attr(
      "style",
      "display: flex; flex-direction: column; gap: 45px; font-family: Roboto, sans-serif; margin: 30px; min-height: 682px; width: 887px; padding: 30px 45px; background-color: none; color: black; position: relative;"
    );
    $(".certificate-module .main-container").append(
      `<img id="bg-img" src="../image/certificates/certificate-2-bg.png" style="position: absolute; z-index: 1; top: 0; left: 0; max-width: 887px; max-height: 700px;" />`
    );
    $(".certificate-module .main-container .certificate-sections").css({
      "z-index": "2",
    });
    $(".certificate-module").css({ margin: "0 auto" });
    const cert = $(".main-container");
    $("#bg-img").height(cert.height() + 60);
    $("#bg-img").width(cert.width() + 90);
    $(".submssion-message").hide();
    return true;
  } else if (
    certificate == "certificate8.html" ||
    certificate == "certificate9.html"
  ) {
    $(".certificate-module .main-container").attr(
      "style",
      "display: flex; flex-direction: column; gap: 45px; font-family: Roboto, sans-serif; margin: 30px; min-height: 682px; width: 887px; padding: 30px 45px; background-color: none; color: black; position: relative;"
    );
    $(".certificate-module .main-container").append(
      `<img id="bg-img" src="../image/certificates/certificate-8-bg.png" style="position: absolute; z-index: 1; top: 0; left: 0; max-width: 887px; max-height: 700px;" />`
    );
    $(".certificate-module .main-container .certificate-sections").css({
      "z-index": "2",
    });
    $(".certificate-module").css({ margin: "0 auto" });
    const cert = $(".main-container");
    $("#bg-img").height(cert.height() + 60);
    $("#bg-img").width(cert.width() + 90);
    $(".submssion-message").hide();
    return true;
  } else if (
    certificate == "certificate13.html" ||
    certificate == "certificate14.html"
  ) {
    $(".certificate-module .main-container").attr(
      "style",
      "display: flex; flex-direction: column; gap: 45px; font-family: Roboto, sans-serif; margin: 30px; min-height: 682px; width: 887px; padding: 30px 45px; background-color: none; color: black; position: relative;"
    );
    $(".certificate-module .main-container").append(
      `<img id="bg-img" src="../image/certificates/certificate-13-bg.png" style="position: absolute; z-index: 1; top: 0; left: 0; max-width: 887px; max-height: 700px;" />`
    );
    $(".certificate-module .main-container .certificate-sections").css({
      "z-index": "2",
    });
    $(".certificate-module").css({ margin: "0 auto" });
    const cert = $(".main-container");
    $("#bg-img").height(cert.height() + 60);
    $("#bg-img").width(cert.width() + 90);
    $(".submssion-message").hide();
    return true;
  } else if (
    certificate == "certificate5.html" ||
    certificate == "certificate6.html" ||
    certificate == "certificate7.html" ||
    certificate == "certificate10.html" ||
    certificate == "certificate11.html" ||
    certificate == "certificate12.html"
  ) {
    $(".certificate-module").css({ "margin-top": "20px" });
    $(".certificate-module .main-container").width(950);
    $(".certificate-module .main-container>div>div").css({
      "min-height": "500px",
    });
    $(".certificate-module .main-container>div>div").css({
      "justify-content": "space-between",
    });
    $(".submssion-message").hide();
    return true;
  }
  return false;
}

function showHideLanguageSpecificDetails() {
  for (let i = 0; i < _languageNames.length; i++) {
    if (_languageNames[i].label === _defaultLanguage.label) {
      $(`.${_languageNames[i].label.toLocaleLowerCase()}`).show();
    } else {
      $(`.${_languageNames[i].label.toLocaleLowerCase()}`).hide();
    }
  }
}

function setLinkedQuestionLanguage() {
  $("[data-linkedlang]").each(function () {
    if (_languageContainer[_defaultLanguage.tag]) {
      const langVal =
        _languageContainer[_defaultLanguage.tag][$(this).data("linkedlang")];
      if (langVal != null && langVal != "") {
        $(this).text(langVal);
      }
    }
  });
}

function hideUnhideDepedentLinkedQuestions() {
  for (let i = 0; i < _linkedQuestions.length; i++) {
    const isHidden = $(
      `#formio .formio-component-${cleanKey(_linkedQuestions[i].qLinked)}`
    )
      .prop("class")
      .includes("formio-hidden");

    if (isHidden) {
      const linkedQuestionKey = cleanKey(_linkedQuestions[i].key);
      if (_linkedQuestions[i].qType === "Dropdown") {
        $(`#formio .formio-component-${linkedQuestionKey} select`).val("");
      } else {
        $(`#formio .formio-component-${linkedQuestionKey} input`).each(
          function () {
            $(this).prop("checked", false);
          }
        );
      }

      $(`#formio .formio-component-${linkedQuestionKey}`).addClass(
        "formio-hidden"
      );
      $(`#formio .formio-component-${linkedQuestionKey}`).hide();
    }
  }
}

function setDraftData(tempData) {
  const dataToSet = tempData ?? _draftData;

  for (let i = 0; i < dataToSet.length; i++) {
    const draftDataKey = cleanKey(dataToSet[i].key);
    if (dataToSet[i].value) {
      if (dataToSet[i].componentType != "custom") {
        if (
          FormioUtils.getComponent(
            _builderHidden.instance.schema.components,
            dataToSet[i].key
          )
        ) {
          //For all the non-linked questions
          _globalForm
            .getComponent(dataToSet[i].key)
            .setValue(dataToSet[i].value);
          //hideUnhideLinkedQuestions(dataToSet[i].key, dataToSet[i].value);
          hideUnhideLinkedQuestionsSimple(dataToSet[i].key);
        } else if (_globalForm.getComponent(dataToSet[i].key)) {
          _globalForm
            .getComponent(dataToSet[i].key)
            .setValue(dataToSet[i].value); //for editgrid
          let $target = $(`#formio [ref="editgrid-${draftDataKey}-addRow"]`);
          editGridBtnClick($target);
        }
      } else {
        //For all the linked questions
        let linkedQuestion = _linkedQuestions.filter(
          (q) => q.key == dataToSet[i].key
        )[0];
        if (linkedQuestion.qType == "Single Choice") {
          $(
            `#formio [name="${draftDataKey}"][value="${cleanKey(
              dataToSet[i].value
            )}"]`
          ).click();
        } else if (linkedQuestion.qType == "Multiple Choice") {
          let dataValues = dataToSet[i].value.split(";");
          for (item in dataValues) {
            if (dataValues[item]) {
              $(
                `#formio [name="${draftDataKey}"][value="${cleanKey(
                  dataValues[item]
                )}"]`
              ).click();
            }
          }
        } else if (linkedQuestion.qType == "Dropdown") {
          $(`#formio #${draftDataKey}`).val(dataToSet[i].value);
          $(`#formio #${draftDataKey}`).change();
        }
      }
    }
  }
}

async function setWorkflowSurveyResponseForReSubmission(response) {
  const answers = response.surveyResults;

  for (let i = 0; i < _questionList.length; i++) {
    const key = _questionList[i].key;
    const prevAnswers = answers.filter(
      (ans) =>
        ans.primaryQuestion === _questionList[i].question ||
        ans.alias === _questionList[i].question
    );

    if (_questionList[i].type === "file") {
      const id = $.uuid();
      let originalName =
        prevAnswers[0]?.answer.split("/")[
          prevAnswers[0]?.answer.split("/").length - 1
        ];
      if (originalName.includes("\\")) {
        originalName =
          originalName.split("\\")[originalName.split("\\").length - 1];
      }
      const name = id + originalName;
      const blobVal = await getBlob(prevAnswers[0]?.answer);
      const ans = [
        {
          name: name,
          originalName: originalName,
          size: blobVal.size,
          type: blobVal.type,
          url: await blobToBase64(blobVal),
        },
      ];

      _globalForm.getComponent(key)?.setValue(ans);
      setFileType(key);
      continue;
    }
    if (_questionList[i].type === "survey") {
      let ans = {};
      for (let j = 0; j < prevAnswers.length; j++) {
        ans[prevAnswers[j].secondaryQuestion] = prevAnswers[j].answer;
      }
      _globalForm.getComponent(key)?.setValue(ans);
      continue;
    }
    if (_questionList[i].type === "custom") {
      let linkedQuestion = _linkedQuestions.filter((q) => q.key == key)[0];
      const dataLinked = _globalForm
        .getComponent(linkedQuestion.qLinked)
        .getValue();
      if (linkedQuestion.qType == "Single Choice") {
        $(
          `#formio [name="${key}"][value="${cleanKey(
            prevAnswers[0]?.answer
          )}"][data-link="${cleanKey(dataLinked)}"]`
        ).click();
      } else if (linkedQuestion.qType == "Multiple Choice") {
        let dataValues = prevAnswers[0]?.answer
          .substring(0, prevAnswers[0]?.answer.length - 1)
          .split(";");
        for (item in dataValues) {
          if (dataValues[item]) {
            $(
              `#formio [name="${key}"][value="${cleanKey(
                dataValues[item]
              )}"][data-link="${cleanKey(dataLinked)}"]`
            ).click();
          }
        }
      } else if (linkedQuestion.qType == "Dropdown") {
        $(`#formio #${key}`).val(prevAnswers[0]?.answer);
        $(`#formio #${key}`).change();
      }
      continue;
    }
    if (_questionList[i].type === "editgrid") {
      const ans = prevAnswers?.map((x) => JSON.parse(x.answer));
      if (ans) {
        _globalForm.getComponent(key)?.setValue(ans);
      }
      continue;
    }
    if (_questionList[i].type === "selectboxes") {
      const ans = prevAnswers[0]?.answer
        .substring(0, prevAnswers[0]?.answer.length - 1)
        .split(";");
      _globalForm.getComponent(key)?.setValue(ans);
      continue;
    }

    _globalForm.getComponent(key)?.setValue(prevAnswers[0]?.answer);

    const isLinked =
      _linkedQuestions.filter((x) => x.qLinked === key).length > 0;
    if (isLinked) {
      //hideUnhideLinkedQuestions(key, prevAnswers[0]?.answer);
      hideUnhideLinkedQuestionsSimple(key);
    }
  }
}

async function getBlob(url) {
  const file = await fetch(url);
  return await file.blob();
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

function languageChangeTranslation() {
  $("[data-languagetranslation]").each(function () {
    const translationValue = $(this).data("languagetranslation");
    $(this).text(_translationData[_defaultLanguage.tag][translationValue]);
    $(this).prop("lang", _defaultLanguage.tag);
  });
}

function setEmoticonFaceLanguage() {
  const emoticonfaces = FormioUtils.searchComponents(
    _builderHidden.instance.schema.components,
    {
      type: "emoticonfaces",
    }
  );

  if (!emoticonfaces || emoticonfaces.length === 0) {
    return;
  }

  const languageTransslation = _languageContainer[_defaultLanguage.tag];
  if (!languageTransslation) {
    return;
  }

  for (let i = 0; i < emoticonfaces.length; i++) {
    const component = emoticonfaces[i];
    $(
      `#formio .formio-component-${cleanKey(component.key)} .emoticon-option`
    ).each(function () {
      const textToTranslate = $(this).find(".emoticon-label").text();
      console.log(textToTranslate);
      $(this)
        .find(".emoticon-label")
        .text(languageTransslation[textToTranslate]);
    });
  }
}

function cleanCategoryLimit(categoryLimit) {
  _categoryLimit = JSON.parse(categoryLimit);

  for (let i = 0; i < _categoryLimit.length; i++) {
    if (_categoryLimit[i].key === "add-category-limit-unsaved") {
      _categoryLimit.splice(i, 1);
    }
  }
}

function resetMutiSelect() {
  var components = FormioUtils.searchComponents(
    _builderHidden.instance.schema.components,
    { type: "selectboxes" }
  );
  for (i = 0; i < components.length; i++) {
    _globalForm
      .getComponent(components[i].key)
      .setValue(_globalForm.getComponent(components[i].key).getValue());
  }
}

function validateLoginForm(data) {
  $(".form-control.is-invalid").removeClass("is-invalid");
  const isValid = validateRequired(data);

  return isValid;
}

function loadUserAnswers(answers) {
  showLoader(_translationData[_defaultLanguage.tag].loadingSavedData);

  _saveAnswersInterval = setInterval(() => {
    saveUserAnswers();
  }, 5000);

  if (!answers) {
    hideLoader();
    return;
  }

  _userAnswers = JSON.parse(answers);

  setDraftData(_userAnswers);

  hideLoader();
}

function saveUserAnswers() {
  let currentAnswers = getDraftAnswers();

  const stringifiedUserAnswers = JSON.stringify(_userAnswers, null, 0);
  const stringifiedCurrentAnswers = JSON.stringify(currentAnswers, null, 0);

  if (
    stringifiedUserAnswers === stringifiedCurrentAnswers ||
    _submissionStatus !== "NotStarted"
  ) {
    if (_submissionStatus === "Submitted") {
      clearInterval(_saveAnswersInterval);
    }
    return;
  }

  _userAnswers = currentAnswers;

  var data = {
    answers: JSON.stringify(_userAnswers, null, 0),
  };

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/loginsurvey/save-temporary`,
      async: true,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      headers: {
        authorization: `Bearer ${_token}`,
      },
      data: JSON.stringify(data),
      success: function (response) {
        console.log(response);
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
      },
    });
  }, 200);

  console.log(JSON.stringify(_userAnswers, null, 0));
}

function setQuestionGroups() {
  if (!_questionGroups || _questionGroups.length === 0) {
    return;
  }

  if (!_isQuestionGroupRendered) {
    for (let i = 0; i < _questionGroups.length; i++) {
      const components = _globalForm.getComponent(
        _questionGroups[i].key
      ).components;

      _questionGroupsRendered.push({
        key: _questionGroups[i].key,
        components: selectUniqueComponents(
          components,
          _questionGroups[i].count
        ),
      });
    }
  }

  _isQuestionGroupRendered = true;
  renderQuestionGroups();
}

function selectUniqueComponents(arr, n) {
  if (!Array.isArray(arr) || n <= 0 || n > arr.length) {
    return null; // Invalid input or not enough elements.
  }

  const result = [];
  const seen = new Set(); // Use a Set to track seen elements efficiently.

  while (result.length < n) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    const element = arr[randomIndex];

    if (!seen.has(element)) {
      result.push(element);
      seen.add(element);
    }
  }

  return result;
}

function renderQuestionGroups() {
  for (let j = 0; j < _questionGroupsRendered.length; j++) {
    const key = _questionGroupsRendered[j].key;

    const components = _globalForm.getComponent(key).components;

    components.forEach(function (component) {
      const index = _questionGroupsRendered[j].components.findIndex(
        (x) => x.key === component.key
      );
      if (index === -1) {
        const c = _globalForm.getComponent(component.key);
        delete c.validate;
        delete c.component.validate;
        c.redraw();
        $(`#formio .formio-component-${component.key}`).remove();
      }
    });
  }
}

// #endregion

// #region Events

function updateProgressBar(progress) {
  if (!progress) {
    progress = Math.floor((_currentPage * 100) / _totalPages);
  }

  const progressBar = document.querySelector(".progressbar");
  progressBar.setAttribute("aria-valuenow", progress);
  progressBar.style.setProperty("--progress", progress + "%");
}

function submittingForm(submissionData) {
  showLoader();

  setTimeout(() => {
    let isValid = true;

    isValid = validateUniqueness(submissionData) && validateUniqueSubmission();
    if (!isValid) {
      const message = _duplicateSubmissionMessage[_defaultLanguage.tag]
        ? _duplicateSubmissionMessage[_defaultLanguage.tag]
        : _translationData[_defaultLanguage.tag].duplicateSubmission;

      _globalForm.emit("error", submissionData);
      hideLoader();
      showError(message);
      return;
    }

    isValid = validateRequiredForLinkedQuestion();
    if (!isValid) {
      const message = _requiredValidationErrors.join("\n");
      _globalForm.emit("error", submissionData);
      hideLoader();
      showError(message);
      return;
    }

    isValid = validateCategoryLimit();
    if (!isValid) {
      const message = _categoryLimitErrors.join("\n");
      _globalForm.emit("error", submissionData);
      hideLoader();
      showError(message);
      return;
    }

    isValid = validateRanking();
    if (!isValid) {
      _globalForm.emit("error", submissionData);
      hideLoader();
      showError(_translationData[_defaultLanguage.tag].invalidRanking);
      return;
    }

    if (isValid) {
      submitForm(submissionData);
    }

    hideLoader();
  }, 200);
}

function submitForm(submissionData) {
  _submissionStatus = "Submitting";
  _surveyAttempt.surveyId = _surveyId;
  _surveyAttempt.attemptId = _attemptId;
  _surveyAttempt.surveyResults = getSurveyData(submissionData);
  _surveyAttempt.formSubmissionMessageDetails = _formSubmissionMessageAnswers;
  _surveyAttempt.files = _fileUploadData;

  if (_fileUploadData && _fileUploadData.length > 0) {
    const totalSize =
      _fileUploadData.reduce((acc, file) => acc + file.size, 0) / 1024 / 1024;

    if (totalSize > 100) {
      _globalForm.refresh();
      showError(_translationData[_defaultLanguage.tag].fileSizeError);
      return;
    }
  }

  _surveyAttempt.isEmailOptionEnabled = _isEmailOptionEnabled;
  _surveyAttempt.timeTaken =
    (new Date().getTime() - _startTime.getTime()) / 1000;
  const isMobileOrTablet = mobileAndTabletcheck();
  _surveyAttempt.device = isMobileOrTablet ? "Mobile/Tablet" : "Desktop/Laptop";
  _surveyAttempt.browser = isMobileOrTablet
    ? "Mobile Browser"
    : browserDetector();
  _surveyAttempt.attemptLanguage = _defaultLanguage.label;
  if (_workflowDetails?.isEnabled) {
    _surveyAttempt.workflowDetails = getWorkflowDetails();
  }

  $.ajax({
    url: `${__appUrl}/api/submissions`,
    async: false,
    type: "POST",
    dataType: "json",
    contentType: "application/json;charset=UTF-8",
    data: JSON.stringify(_surveyAttempt),
    headers: {
      authorization: `Bearer ${_token}`,
    },
    success: function (response) {
      afterSubmitAction();
      _submissionStatus = "Submitted";
    },
    error: function (err) {
      _submissionStatus = "NotStarted";
      const error = getError(err);
      if (error.messages[0] == "Duplicate") {
        const message = _duplicateSubmissionMessage[_defaultLanguage.tag]
          ? _duplicateSubmissionMessage[_defaultLanguage.tag]
          : _translationData[_defaultLanguage.tag].duplicateSubmission;
        showError(message);
        return;
      }
      showError(error.messages);
    },
  });
}

function afterSubmitAction() {
  showSuccessSurveySubmission(
    _translationData[_defaultLanguage.tag].submittedDetails,
    () => {
      if (_enablePrinting) {
        printSurveyAfterSubmission();
      }

      let submissionMessage = _languageContainer[_defaultLanguage.tag]
        ?.commonProps?.surveyMessage
        ? _languageContainer[_defaultLanguage.tag].commonProps.surveyMessage
        : _submissionMessage;

      if (_workflowDetails?.isEnabled) {
        const uniquekey = _workflowUniqueKey;

        if (submissionMessage.toLowerCase().indexOf("{uniquekey}") !== -1) {
          submissionMessage = submissionMessage.replace(
            /{uniquekey}/g,
            uniquekey
          );
        } else {
          submissionMessage += ` ${_translationData[
            _defaultLanguage.tag
          ].uniqueKeyIs.replace("{UNIQUEKEY}", uniquekey)}`;
        }
      }

      hideSurveyAndShowMessage(submissionMessage);

      let submissionLogoHtml = "";
      if (_submissionLogos.length > 0) {
        submissionLogoHtml = _submissionLogos.map((x) => {
          return `<div>${x}</div>`;
        });
      }
      if (submissionLogoHtml) {
        $(".survey-submission").append(submissionLogoHtml.join(""));
      }

      printCertificate();
    }
  );
}

function getSurveyData(submission) {
  var result = [];
  for (let question in submission.data) {
    const cleanQuestion = cleanKey(question);
    if (question.trim() !== "" && question != "submit") {
      const component = FormioUtils.getComponent(
        _builderHidden.instance.schema.components,
        question
      );
      const questionType = component ? component.type : "editgrid";
      if (questionType == "selectboxes") {
        let surveyAnswers = "";
        if (
          $(`#formio .formio-component-${cleanQuestion}`)
            ?.attr("class")
            ?.split(" ")
            ?.indexOf("rank") != -1
        ) {
          if (
            $(`#formio .formio-component-${cleanQuestion}`)
              ?.attr("class")
              ?.split(" ")
              ?.indexOf("reorder") != -1
          ) {
            for (let items in submission.data[question]) {
              if (submission.data[question][items]) {
                const val = $(
                  `.formio-component-${cleanQuestion} .form-check:visible label [data-choiceval="${cleanKey(
                    items
                  )}"]`
                ).val();
                surveyAnswers += `${items}~${val};`;
              }
            }
          } else {
            for (var items in submission.data[question]) {
              if (submission.data[question][items]) {
                const val = $(
                  `.formio-component-${cleanQuestion} .form-check label [data-choiceval="${cleanKey(
                    items
                  )}"]`
                ).val();
                surveyAnswers += `${items}~${val};`;
              }
            }
          }
        } else {
          for (var items in submission.data[question]) {
            if (submission.data[question][items]) {
              surveyAnswers += `${items};`;
            }
          }
        }

        if (surveyAnswers) {
          result.push({
            primaryQuestion: component.label.trim(),
            secondaryQuestion: "",
            answer: surveyAnswers,
            questionType: questionType,
            alias: _alias[question]?.trim(),
            key: question,
          });
        }
      } else if (questionType == "survey") {
        const surveyQuestions = component.questions;
        for (let i = 0; i < surveyQuestions.length; i++) {
          for (let items in submission.data[question]) {
            if (surveyQuestions[i].value == items) {
              result.push({
                primaryQuestion: component.label.trim(),
                secondaryQuestion: surveyQuestions[i].value.trim(),
                answer: submission.data[question][items],
                questionType: questionType,
                alias: _alias[question]?.trim(),
                key: question,
              });
              break;
            }
          }
        }
      } else if (questionType == "file") {
        addFileUploadData(result, question, questionType, submission);
      } else if (questionType == "editgrid") {
        const editgridCompoenent = FormioUtils.searchComponents(
          _builderHidden.instance.schema.components,
          { key: question }
        )[0];
        const editgridQuestion = editgridCompoenent.label;
        let innerAnswer = {};
        for (let i = 0; i < submission.data[question].length; i++) {
          innerAnswer = {};
          for (key in submission.data[question][i]) {
            const innerQComponent = FormioUtils.searchComponents(
              _builderHidden.instance.schema.components,
              { key: key }
            );
            const innerQuestion = innerQComponent ? innerQComponent[0] : "";
            if (innerQuestion) {
              if (
                innerQuestion.type === "file" &&
                submission.data[question][i][key] != null &&
                submission.data[question][i][key].length > 0
              ) {
                addFileUploadData(
                  result,
                  question,
                  questionType,
                  submission.data[question][i][key][0],
                  true,
                  innerQuestion
                );
                innerAnswer[
                  innerQuestion.label
                ] = `${submission.data[question][i][key][0].name}`;
              } else {
                innerAnswer[innerQuestion.label] =
                  submission.data[question][i][key];
              }
            }
          }

          result.push({
            primaryQuestion: editgridQuestion.trim(),
            secondaryQuestion: "",
            answer: JSON.stringify(innerAnswer),
            questionType: "Multi-Data",
            alias: _alias[question]?.trim(),
            key: question,
          });
        }
      } else if (questionType == "datetime") {
        var answer = $("#formio")
          .find(`.formio-component-${cleanQuestion}`)
          .find(".input-group")
          .find(".input")
          .val();
        result.push({
          primaryQuestion: component.label.trim(),
          secondaryQuestion: "",
          answer:
            answer ??
            formatDateTimeForSurveyForm(
              submission.data[question],
              "dd-MM-yyyy hh:mm:ss"
            ),
          questionType: questionType,
          alias: _alias[question]?.trim(),
          key: question,
        });
      } else if (
        questionType.toLowerCase() == "phonenumber" ||
        questionType.toLowerCase() == "email"
      ) {
        result.push({
          primaryQuestion: component.label.trim(),
          secondaryQuestion: "",
          answer: submission.data[question],
          questionType: questionType,
          alias: _alias[question]?.trim(),
          key: question,
        });

        const formSubmissionMessage = _formSubmissionMessageDetails.filter(
          (item) => item.key === question
        );
        if (formSubmissionMessage && formSubmissionMessage.length > 0) {
          const message =
            _defaultLanguage.tag === "ar"
              ? formSubmissionMessage[0].messageAr
              : formSubmissionMessage[0].messageEn;

          setFormSubmissionMessageAnswers(
            question,
            submission.data[question],
            questionType.toLowerCase(),
            message
          );
        }
      } else if (questionType == "custom") {
      } else if (questionType == "emoticonfaces") {
        result.push({
          primaryQuestion: component.label.trim(),
          secondaryQuestion: "",
          answer: getEmoticonFacesAnswer(question, submission.data[question]),
          questionType: questionType,
          alias: _alias[question]?.trim(),
          key: question,
        });
      } else {
        result.push({
          primaryQuestion: component.label.trim(),
          secondaryQuestion: "",
          answer: submission.data[question],
          questionType: questionType,
          alias: _alias[question]?.trim(),
          key: question,
        });
      }
    }
  }

  for (let j = 0; j < _linkedQuestions.length; j++) {
    if (!_linkedQuestions[j].isMultidata) {
      const questionType =
        _linkedQuestions[j].qType == "Dropdown"
          ? "select"
          : _linkedQuestions[j].qType == "Multiple Choice"
          ? "selectboxes"
          : "radio";

      result.push({
        primaryQuestion: _linkedQuestions[j].label.trim(),
        secondaryQuestion: "",
        answer: getLinkedQuestionAnswer(j),
        questionType: questionType,
        alias: _alias[_linkedQuestions[j].key]?.trim(),
        key: _linkedQuestions[j].key,
      });
    }
  }

  for (j = 0; j < _linkedData.length; j++) {
    const key = _linkedData[j].key;
    const linkedQ = result.filter((item) => item.key == key);
    if (linkedQ.length > 0) {
      let answer = linkedQ[0].answer;
      let data =
        _linkedData[j].type === "survey"
          ? _linkedSurveyData.filter((x) => x.key === key && answer === answer)
          : _linkedData[j].data.filter((item) => item[key] == answer);

      if (data && data.length > 0) {
        if (_linkedData[j].type === "survey") {
          data = data[0].data;

          for (let k = 0; k < data.length; k++) {
            const component = FormioUtils.findComponents(
              _builderHidden.instance.schema.components,
              { label: data[k].primaryQuestion }
            )[0];
            if (
              component &&
              $(`#formio .formio-component-${cleanKey(component.key)}`)
                ?.attr("class")
                ?.split(" ")
                .indexOf("formio-hidden") !== -1
            ) {
              if (
                result.filter(
                  (x) =>
                    x.primaryQuestion.trim() == component.label.trim() &&
                    x.answer != undefined &&
                    x.answer != null &&
                    x.answer != ""
                ).length == 0
              ) {
                result.push({
                  primaryQuestion: component.label.trim(),
                  secondaryQuestion: "",
                  answer: data[k].answer,
                  questionType:
                    component.type == "editgrid"
                      ? "Multi-Data"
                      : component.type,
                  alias: data[k].alias?.trim(),
                  key: component.key,
                });
              }
            }
          }
        } else {
          for (item in data[0]) {
            if (
              $(`#formio .formio-component-${cleanKey(item)}`)
                .attr("class")
                ?.split(" ")
                .indexOf("formio-hidden") != -1
            ) {
              const component = FormioUtils.getComponent(
                _builderHidden.instance.schema.components,
                item
              );
              if (
                result.filter(
                  (x) =>
                    x.primaryQuestion.trim() == component.label.trim() &&
                    x.answer != undefined &&
                    x.answer != null &&
                    x.answer != ""
                ).length == 0
              ) {
                result.push({
                  primaryQuestion: component.label.trim(),
                  secondaryQuestion: "",
                  answer: data[0][item],
                  questionType:
                    component.type == "editgrid"
                      ? "Multi-Data"
                      : component.type,
                  alias: _alias[item]?.trim(),
                  key: component.key,
                });
              }
            }
          }
        }
      }
    }
  }

  return result;
}

function getEmoticonFacesAnswer(key, value) {
  const component = _globalForm.getComponent(key).component;
  const numberOfFaces = component.numberOfFaces;
  const labels = component.faceLabels[numberOfFaces];
  return labels[value - 1] || value;
}

function addFileUploadData(
  result,
  question,
  questionType,
  submission,
  isPartOfMultiData,
  innerQ
) {
  var fileClasses = $(`#formio .formio-component-${cleanKey(question)}`)
    ?.attr("class")
    ?.split(" ");
  if (!fileClasses || fileClasses.length == 0) {
    return;
  }
  var isFileValidType =
    fileClasses.filter((cls) => cls == "file").length > 0 ? true : false;
  if (isPartOfMultiData) {
    fileClasses = innerQ.customClass.split(" ");
    isFileValidType =
      fileClasses.filter((cls) => cls == "file").length > 0 ? true : false;
  }
  if (isFileValidType) {
    const component = FormioUtils.getComponent(
      _builderHidden.instance.schema.components,
      question
    );
    if (isPartOfMultiData) {
      if (fileClasses.includes("voice")) {
        const recordingIndex = _recordingData.findIndex(
          (x) => x.key === innerQ.key
        );
        if (recordingIndex != -1) {
          _fileUploadData.push({
            primaryQuestion: component.label.trim(),
            name: _recordingData[recordingIndex].name,
            size: (_recordingData[recordingIndex].data.length * 6) / 8,
            url: _recordingData[recordingIndex].data,
            key: question,
            alias: _alias[innerQ.key]?.trim(),
          });
        }
      } else {
        _fileUploadData.push({
          primaryQuestion: component.label.trim(),
          name: submission.name,
          size: submission.size,
          url: submission.url,
          key: question,
          alias: _alias[innerQ.key]?.trim(),
        });
      }
    } else {
      if (
        submission.data[question].length > 0 ||
        fileClasses.includes("voice")
      ) {
        result.push({
          primaryQuestion: component.label.trim(),
          secondaryQuestion: "",
          answer: "",
          questionType: questionType,
          alias: _alias[question]?.trim(),
          key: question,
        });
      }

      if (
        submission.data[question].length > 0 &&
        !fileClasses.includes("voice")
      ) {
        _fileUploadData.push({
          primaryQuestion: component.label.trim(),
          name: submission.data[question][0].originalName,
          size: submission.data[question][0].size,
          url: submission.data[question][0].url,
          key: question,
          alias: _alias[question]?.trim(),
        });
      } else {
        const recordingIndex = _recordingData.findIndex(
          (x) => x.key === question
        );
        if (recordingIndex != -1) {
          _fileUploadData.push({
            primaryQuestion: component.label.trim(),
            name: _recordingData[recordingIndex].name,
            size: (_recordingData[recordingIndex].data.length * 6) / 8,
            url: _recordingData[recordingIndex].data,
            key: question,
            alias: _alias[question]?.trim(),
          });
        }
      }
    }
  }
}

function setFormSubmissionMessageAnswers(key, value, type, message) {
  _formSubmissionMessageAnswers.push({
    key: key,
    value: value,
    type: type,
    lang: _defaultLanguage.label.toLocaleLowerCase(),
    message: message,
  });
}

function getLinkedQuestionAnswer(index) {
  let ans = "";
  const linkedQuestionKey = cleanKey(_linkedQuestions[index].key);
  if (_linkedQuestions[index].qType == "Dropdown") {
    ans = $(`#${linkedQuestionKey}`).val();
  } else if (_linkedQuestions[index].qType == "Single Choice") {
    ans = $(`[name="${linkedQuestionKey}"]:checked`).val();
  } else if (_linkedQuestions[index].qType == "Multiple Choice") {
    $(`[name="${linkedQuestionKey}"]:checked`).each(function () {
      ans += $(this).val() + ";";
    });
  }

  if (ans) {
    return ans;
  } else {
    return "";
  }
}

function setLinkedSurveyDataFields(key, e) {
  const linkedSurveyDataCurrent = _linkedSurveyData.filter(
    (x) => x.key === key
  );
  const surveyIds = _linkedData
    .filter((x) => x.key === key && x.type === "survey")
    .map((x) => x.data);
  const primaryQuestion = _globalForm.getComponent(key).label;
  const answer = _globalForm.getComponent(key).getValue();

  if (!answer) {
    return;
  }

  if (linkedSurveyDataCurrent && linkedSurveyDataCurrent.length > 0) {
    if (
      linkedSurveyDataCurrent[0].primaryQuestion === primaryQuestion &&
      linkedSurveyDataCurrent[0].answer === answer
    ) {
      setLinkedSurveyDataAnswers(
        linkedSurveyDataCurrent[0].data,
        primaryQuestion
      );
      return;
    }

    let linkedDataIndex = _linkedSurveyData.findIndex(
      (item) => item.key === key
    );
    if (linkedDataIndex != -1) {
      _linkedSurveyData.splice(linkedDataIndex, 1);
    }
  }

  const data = {
    surveyId: surveyIds[0],
    question: primaryQuestion,
    answer: answer,
  };

  if (surveyIds && surveyIds.length > 0) {
    showLoader();

    setTimeout(() => {
      $.ajax({
        url: `${__appUrl}/api/submissions/linked-survey-submission-data`,
        async: false,
        type: "POST",
        dataType: "json",
        contentType: "application/json;charset=UTF-8",
        data: JSON.stringify(data),
        success: function (response) {
          _linkedSurveyData.push({
            key,
            primaryQuestion,
            answer,
            data: response,
          });
          setLinkedSurveyDataAnswers(response, primaryQuestion);
        },
      });

      hideLoader();
    }, 200);
  }
}

function generateLinkedQuestionHtml() {
  for (i = 0; i < _linkedQuestions.length; i++) {
    const linkedQuestionKey = cleanKey(_linkedQuestions[i].key);
    try {
      let requiredIndicator = _linkedQuestions[i].isRequired
        ? '<span class="text-danger">*</span>'
        : "";
      let linkedOutputHtml = `<label data-linkedLang="${_linkedQuestions[i].label}" class="col-form-label">${_linkedQuestions[i].label}</label> ${requiredIndicator}`;
      let rClass = _linkedQuestions[i].isRequired ? "required" : "";
      if (_linkedQuestions[i].qType == "Dropdown") {
        linkedOutputHtml += `<div data-qtype="custom" class="form-group" data-type="select-one" dir="ltr" tabindex="-1" role="combobox" aria-autocomplete="list" aria-haspopup="true" aria-expanded="false">`;
        linkedOutputHtml += `<select onchange="hideUnhideLinkedQuestionsSimple('${_linkedQuestions[i].key}','',this)" class="form-control decorated ${rClass}" id="${_linkedQuestions[i].key}" name="${_linkedQuestions[i].key}"><option value='' selected disabled></option>`;
        for (key in _linkedQuestions[i].value) {
          for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
            linkedOutputHtml += `<option data-linkedLang="${_linkedQuestions[i].value[key][j]}" class="custom-question-option" data-link='${key}' value='${_linkedQuestions[i].value[key][j]}'>${_linkedQuestions[i].value[key][j]}</option>`;
          }
        }
        linkedOutputHtml += `</select></div>`;
      } else if (_linkedQuestions[i].qType == "Single Choice") {
        linkedOutputHtml += `<div class="form-radio radio">`;
        for (key in _linkedQuestions[i].value) {
          for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
            linkedOutputHtml += `<div data-qtype="custom" style="display:flex;gap:0.5rem;align-items:center;"><input class="${rClass}" onclick="hideUnhideLinkedQuestionsSimple('${_linkedQuestions[i].key}','',this)" data-link='${key}' type="radio" name="${_linkedQuestions[i].key}" value="${_linkedQuestions[i].value[key][j]}" /><span data-linkedLang="${_linkedQuestions[i].value[key][j]}">${_linkedQuestions[i].value[key][j]}</span></div>`;
          }
        }
        linkedOutputHtml += `</div>`;
      } else if (_linkedQuestions[i].qType == "Multiple Choice") {
        linkedOutputHtml += `<div class="form-radio radio">`;
        for (key in _linkedQuestions[i].value) {
          for (j = 0; j < _linkedQuestions[i].value[key].length; j++) {
            linkedOutputHtml += `<div data-qtype="custom" style="display:flex;gap:0.5rem;align-items:center;"><input class="${rClass}" onclick="hideUnhideLinkedQuestionsSimple('${_linkedQuestions[i].key}','',this)" data-link='${key}' type="checkbox" name="${_linkedQuestions[i].key}" value="${_linkedQuestions[i].value[key][j]}" /><span data-linkedLang="${_linkedQuestions[i].value[key][j]}">${_linkedQuestions[i].value[key][j]}</span></div>`;
          }
        }
        linkedOutputHtml += `</div>`;
      }

      if (`.formio-component-${linkedQuestionKey}:visible`) {
        $(`#formio .formio-component-${linkedQuestionKey}`).html(
          linkedOutputHtml
        );
        $(`#formio .formio-component-${linkedQuestionKey}`).hide();
        $(`#formio .formio-component-${linkedQuestionKey}`).addClass(rClass);
      }
    } catch (e) {
      console.log(e);
    }
  }
}

// Depricated
function hideUnhideLinkedQuestions(key, val, e) {
  if (key == "") {
    return "";
  } else {
    for (let i = 0; i < _linkedQuestions.length; i++) {
      try {
        if (_linkedQuestions[i].qLinked == key) {
          // TODO: check if this is required
          const qType = FormioUtils.getComponent(
            _builderHidden.instance.schema.components,
            key
          ).type;
          const qLinkedType = _linkedQuestions[i].qType;
          if (qType == "custom") {
            let vals = [];
            if (
              _linkedQuestions.filter((x) => x.key == key)[0].qType ==
              "Multiple Choice"
            ) {
              $(
                `#formio .formio-component-${key} .form-radio input:checked`
              ).each(function () {
                vals.push($(this).val());
              });
            } else {
              vals = $(e).val();
            }

            if (val == null && e == null) {
              $("#formio .formio-component-" + _linkedQuestions[i].key).hide();
            } else {
              $("#formio .formio-component-" + _linkedQuestions[i].key).show();
              if (
                qLinkedType == "Single Choice" ||
                qLinkedType == "Multiple Choice"
              ) {
                $(`#formio .formio-component-${_linkedQuestions[i].key} input`)
                  .parent()
                  .hide();
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} input`
                ).prop("checked", false);
                if (Array.isArray(vals)) {
                  const arr = vals;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${arr[j]}"]`
                    )
                      .parent()
                      .show();
                    if (
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${arr[j]}"]`
                      ).parent().length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${vals}"]`
                  )
                    .parent()
                    .show();
                  if (
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${vals}"]`
                    ).parent().length == 0
                  ) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                }

                if (!vals || vals.length == 0) {
                  $(
                    "#formio .formio-component-" + _linkedQuestions[i].key
                  ).hide();
                }
              } else if (qLinkedType == "Dropdown") {
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select option`
                ).hide();

                if (Array.isArray(vals)) {
                  const arr = vals;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${arr[j]}"]`
                    ).show();
                    if (
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${arr[j]}"]`
                      ).length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${key1}"]`
                      ).show();
                      if (
                        $(
                          `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${key1}"]`
                        ).length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${vals}"]`
                  ).show();
                  if (
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${vals}"]`
                    ).length == 0
                  ) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                }

                if (!vals || vals.length == 0) {
                  $(
                    "#formio .formio-component-" + _linkedQuestions[i].key
                  ).hide();
                }
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select option[value='']`
                ).show();
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select`
                ).val("");
              }
            }

            //hideUnhideLinkedQuestions(_linkedQuestions[i].key, null, null);
            hideUnhideLinkedQuestionsSimple(_linkedQuestions[i].key);
          } else {
            if (val == null && e == null) {
              $("#formio .formio-component-" + _linkedQuestions[i].key).hide();
            } else {
              $("#formio .formio-component-" + _linkedQuestions[i].key).show();
              if (
                qLinkedType == "Single Choice" ||
                qLinkedType == "Multiple Choice"
              ) {
                $(`#formio .formio-component-${_linkedQuestions[i].key} input`)
                  .parent()
                  .hide();
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} input`
                ).prop("checked", false);

                if (Array.isArray(val)) {
                  const arr = val;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${arr[j]}"]`
                    )
                      .parent()
                      .show();
                    if (
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${arr[j]}"]`
                      ).parent().length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${key1}"]`
                      )
                        .parent()
                        .show();
                      if (
                        $(
                          `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${key1}"]`
                        ).parent().length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else if (val) {
                  $(
                    `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${val}"]`
                  )
                    .parent()
                    .show();
                  if (
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} input[data-link="${val}"]`
                    ).parent().length == 0
                  ) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                }
              } else if (qLinkedType == "Dropdown") {
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select option`
                ).hide();

                if (Array.isArray(val)) {
                  const arr = val;
                  let validCount = 0;
                  for (j = 0; j < arr.length; j++) {
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${arr[j]}"]`
                    ).show();
                    if (
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${arr[j]}"]`
                      ).length > 0
                    ) {
                      validCount++;
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else if ({}.constructor == val.constructor) {
                  let validCount = 0;
                  for (key1 in val) {
                    if (val[key1]) {
                      $(
                        `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${key1}"]`
                      ).show();
                      if (
                        $(
                          `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${key1}"]`
                        ).length > 0
                      ) {
                        validCount++;
                      }
                    }
                  }
                  if (validCount == 0) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                } else {
                  $(
                    `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${val}"]`
                  ).show();
                  if (
                    $(
                      `#formio .formio-component-${_linkedQuestions[i].key} select option[data-link="${val}"]`
                    ).length == 0
                  ) {
                    $(
                      "#formio .formio-component-" + _linkedQuestions[i].key
                    ).hide();
                  }
                }
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select option[value='']`
                ).show();
                $(
                  `#formio .formio-component-${_linkedQuestions[i].key} select`
                ).val("");
              }
            }

            hideUnhideLinkedQuestions(_linkedQuestions[i].key, null, null);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    // TODO: check if this is required
    if (
      e &&
      $(e).val() &&
      FormioUtils.getComponent(_builderHidden.instance.schema.components, key)
        .type == "custom"
    ) {
      _globalForm.getComponent(key).setValue($(e).val());
    }
    //setNextBtn();

    return "";
  }
}

function hideUnhideLinkedQuestionsSimple(key) {
  if (key === "" || key === null) {
    return "";
  }

  let linkedQuestionsToShow = _linkedQuestions.filter(
    (x) => x.qLinked === key && !x.multidataQuestion
  );

  if (linkedQuestionsToShow.length == 0) {
    //setNextBtn();
    return "";
  }

  hideLinkedQuestionsOnChange(linkedQuestionsToShow);

  const currentQuestionType = FormioUtils.getComponent(
    _builderHidden.instance.schema.components,
    key
  ).type;

  const currentLinkedQuestion =
    currentQuestionType === "custom"
      ? _linkedQuestions.filter((x) => x.key === key)[0]
      : null;

  const currentQuestionAnswers = currentLinkedQuestion
    ? currentLinkedQuestion.qType == "Dropdown"
      ? $(`[name="${cleanKey(currentLinkedQuestion.key)}"]`).val()
      : $(`[name="${cleanKey(currentLinkedQuestion.key)}"]:checked`).val()
    : _globalForm.getComponent(key).getValue();

  for (let i = 0; i < linkedQuestionsToShow.length; i++) {
    let availableLinkedAnswers;
    const linkedQuestionToShowKey = cleanKey(linkedQuestionsToShow[i].key);
    if (Array.isArray(currentQuestionAnswers)) {
      currentQuestionAnswers.forEach(function (x) {
        availableLinkedAnswers[x] = linkedQuestionsToShow[i].value[x];
      });
    } else {
      availableLinkedAnswers =
        linkedQuestionsToShow[i].value[currentQuestionAnswers];
    }

    if (!availableLinkedAnswers) {
      continue;
    }

    if (linkedQuestionsToShow[i].qType == "Dropdown") {
      $(
        `#formio .formio-component-${linkedQuestionToShowKey} select option`
      ).hide();

      if (!Array.isArray(currentQuestionAnswers)) {
        $(
          `#formio .formio-component-${linkedQuestionToShowKey} select option[data-link="${currentQuestionAnswers}"]`
        ).show();
      } else {
        currentQuestionAnswers.forEach(function (x) {
          $(
            `#formio .formio-component-${linkedQuestionToShowKey} select option[data-link="${x}"]`
          ).show();
        });
      }
    } else {
      $(
        `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div`
      ).hide();
      if (!Array.isArray(currentQuestionAnswers)) {
        $(
          `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div input[data-link="${cleanKey(
            currentQuestionAnswers
          )}"]`
        )
          .parent()
          .show();
      } else {
        currentQuestionAnswers.forEach(function (x) {
          $(
            `#formio .formio-component-${linkedQuestionToShowKey} .form-radio.radio div input[data-link="${x}"]`
          )
            .parent()
            .show();
        });
      }
    }
    $(`#formio .formio-component-${linkedQuestionToShowKey}`).show();
  }

  //setNextBtn();
}

function hideLinkedQuestionsOnChange(linkedQuestionsToShow) {
  if (linkedQuestionsToShow == null || linkedQuestionsToShow.length == 0) {
    return;
  }

  for (i = 0; i < linkedQuestionsToShow.length; i++) {
    const linkedQuestionKey = cleanKey(linkedQuestionsToShow[i].key);
    $(`#formio .formio-component-${linkedQuestionKey}`).hide();
    if (linkedQuestionsToShow[i].qType == "Dropdown") {
      $(`#formio .formio-component-${linkedQuestionKey} select`).val("");
    } else {
      $(
        `#formio .formio-component-${linkedQuestionKey} .form-radio.radio div input`
      ).each(function () {
        $(this).prop("checked", false);
      });
    }
    const childLinkedQuestions = _linkedQuestions.filter(
      (x) => x.qLinked === linkedQuestionsToShow[i].key
    );

    hideLinkedQuestionsOnChange(childLinkedQuestions);
  }
}

function editGridBtnClick(e) {
  // TODO: check if key can be passed
  setCustomCss();

  let ref = $(e).attr("ref");

  if (
    $('#formio [ref="' + ref + '"]')
      .parent()
      .find(".formio-component-custom").length > 0
  ) {
    generateLinkedQuestionHtmlEditGrid(
      ref.replace("-addRow", "").replace("editgrid-", "")
    );
    setCustomCssForLinkedQuestion();

    $('#formio [ref="' + ref + '"]')
      .parent()
      .find(`[ref="${ref.replace("-addRow", "")}-saveRow"]`)
      .addClass("multidataLinkedSave");
  }

  //Save multidata linked questions
  if ($(e).hasClass("multidataLinkedSave")) {
    ref = $(e).attr("ref").replace("-saveRow", "").replace("editgrid-", "");
    let rowNum = -1;
    let innerComponents = _globalForm
      .getComponent(ref)
      .component.components.map((x) => x.key);
    if (_multidataLinkedDetails[ref]) {
      let multiDataObj = {};
      let multidataLinkedLatest = _multidataLinkedDetails[ref].pop();
      for (i = 0; i < innerComponents.length; i++) {
        multiDataObj[innerComponents[i]] = _multidataLinkedCurrent[
          innerComponents[i]
        ]
          ? _multidataLinkedCurrent[innerComponents[i]]
          : multidataLinkedLatest[innerComponents[i]]
          ? multidataLinkedLatest[innerComponents[i]]
          : "";
      }

      _multidataLinkedDetails[ref].push(multiDataObj);
    } else {
      _multidataLinkedDetails[ref] = [];
      let multiDataObj = {};
      let multidataLinkedLatest = _globalForm.getComponent(ref).getValue()[0];
      for (i = 0; i < innerComponents.length; i++) {
        multiDataObj[innerComponents[i]] = _multidataLinkedCurrent[
          innerComponents[i]
        ]
          ? _multidataLinkedCurrent[innerComponents[i]]
          : multidataLinkedLatest[innerComponents[i]]
          ? multidataLinkedLatest[innerComponents[i]]
          : "";
      }
      _multidataLinkedDetails[ref].push(multiDataObj);
    }
    _multidataLinkedCurrent = {};
    _globalForm.getComponent(ref).setValue(_multidataLinkedDetails[ref]);
    _globalForm.getComponent(ref).redraw();
    $(`[ref="editgrid-${ref}-row"]:nth-of-type(${rowNum + 1}`)
      .find(".removeRow")
      .data("rownum", rowNum);
    $(`[ref="editgrid-${ref}-row"]:nth-of-type(${rowNum + 1}`)
      .find(".removeRow")
      .data("ref", ref);
    $(`[ref="editgrid-${ref}-row"]:nth-of-type(${rowNum + 1}`)
      .find(".removeRow")
      .addClass("multidataLinkedRemove");
    $(`[ref="editgrid-${ref}-row"] .editRow`).remove();
  } else if ($(e).hasClass("multidataLinkedRemove")) {
    ref = $(e).data("ref");
    let rowNum = $(e).data("rownum");
    _multidataLinkedDetails[ref].splice(rowNum, 1);
    _globalForm.getComponent(ref).setValue(_multidataLinkedDetails[ref]);
    _globalForm.getComponent(ref).redraw();
  }
  $(".formio-component-editgrid button").each(function () {
    $(this).attr("onclick", "editGridBtnClick(this)");
  });
  shuffleRadio();
  shuffleMultiChoice();

  // Edit grid language change
  editGridLanguageChange(_defaultLanguage.tag);
}

function updateLanguage(e) {
  const language = $(e).val();
  if (_defaultLanguage?.label !== language) {
    _defaultLanguage = _languageNames.filter((x) => x.label === language)[0];

    _userLanguage = _defaultLanguage.tag;

    setLanguage(_defaultLanguage.tag);
    editGridLanguageChange(_defaultLanguage.tag);
    setSurveyTitle();
    setSurveyImages();
    generateLinkedQuestionHtml();
    setLinkedQuestionLanguage();
    setNavigation();
    setCustomCssForLinkedQuestion();
    showHideLanguageSpecificDetails();
    setCustomCss();
    languageChangeTranslation();
    setEmoticonFaceLanguage();

    $("body").prop("lang", _defaultLanguage.tag);
  }
}

function addRecoderForm(key) {
  $("body").append(`
    <div class="modal fade" id="${key}-recoder-modal" tabindex="-1" role="dialog" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" data-translation="lbl_recordaudio">
              ${_translationData[_defaultLanguage.tag].recordAudio}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="fa fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <section class="main-controls">
              <canvas class="visualizer" height="0px"></canvas>
              <div id="buttons" style="display: flex; gap: 15px; justify-content: center;">
                <button class="record btn btn-info" data-translation="btn_record">${
                  _translationData[_defaultLanguage.tag].record
                }</button>
                <button class="stop btn btn-info" data-translation="btn_stop">${
                  _translationData[_defaultLanguage.tag].stop
                }</button>
              </div>
            </section>

            <section class="sound-clips" style="display: flex; flex-direction: column; margin-top: 20px;">


            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary waves-effect waves-themed" onclick="closeRecorderModal('${key}')" data-translation="btn_close">${
    _translationData[_defaultLanguage.tag].close
  }</button>
            <button type="button" class="btn btn-primary waves-effect waves-themed" onclick="saveRecorderData('${key}')" data-translation="btn_save">${
    _translationData[_defaultLanguage.tag].save
  }</button>
          </div>
        </div>
      </div>
    </div>
  `);

  setupRecorderVariables(key);

  //translateStatic(_currentLang, _directionContainer[_currentLang]);

  $(`#${key}-recoder-modal`).modal("show");

  $("#recoder-modal .visualizer").css({ width: "100%" });
}

function generateOTP(e, key) {
  let phoneNumber = $(e).parent().find("input").val();
  key = key.trim();
  let time = 180;

  if (phoneNumber) {
    showLoader();

    setTimeout(() => {
      const data = {
        surveyId: _surveyId,
        phoneNumber: phoneNumber,
        language: _defaultLanguage.label,
      };

      $.ajax({
        url: `${__appUrl}/api/notifications/send-otp`,
        async: false,
        type: "POST",
        dataType: "text",
        contentType: "application/json;charset=UTF-8",
        data: JSON.stringify(data),
        success: function (response) {
          $(e).hide();
          $(`.${key}-otp-error`).text("");
          // $(`.${key}-label`).removeClass("text-danger");
          $(e).parent().append(`
            <div class="row m-0 pt-5 ${key}-otp-submission">
              <label data-translation="otp-label" class="form-label">OTP</label>
              <input class="${key}-otp form-control message-otp" type="text" title="${
            _translationData[_defaultLanguage.tag].enterOtpHere
          }" />
              <div style="display:flex; flex-direction: column;">
                <label class="text-danger error-message-otp ${key}-otp-error"></label>
                <label data-languagetranslation="otpValidFor" class="text-primary otp-countdown">${
                  _translationData[_defaultLanguage.tag].otpValidFor
                } <span class="${key}-otp-countdown-time">${time}</span> sec</label>
                <button data-languagetranslation="submitOtp" class="btn btn-success mt-2 ${key}-btn" onclick="submitOTP(this,'${key}')">
                  ${_translationData[_defaultLanguage.tag].submitOtp}
                </button>
              </div>
            </div>
          `);

          let otptimer = setInterval(function () {
            if (time > 0) {
              time--;
              $(`.${key}-otp-countdown-time`).text(time);
            } else {
              clearInterval(otptimer);
              $(`.${key}-btn`).show();
              $(`.${key}-otp-submission`).remove();
              // $(`.${key}-label`).addClass("text-danger");
              $(`.${key}-otp-error`).text(
                _translationData[_defaultLanguage.tag].otpExpired
              );
            }
          }, 1000);
        },
        error: function (err) {
          const error = getError(err);
          showError(error.messages);
        },
      });

      hideLoader();
    }, 100);
  } else {
    showError(_translationData[_defaultLanguage.tag].otpMobileNum);
  }
}

function submitOTP(e, key) {
  const cleanedKey = cleanKey(key);
  let otp = $(`.${cleanedKey}-otp`).val();
  if (isNaN(otp)) {
    $(`.${cleanedKey}-otp-error`).addClass("text-danger");
    $(`.${cleanedKey}-otp-error`).text(
      _translationData[_defaultLanguage.tag].otpIncorrect
    );
    return;
  }
  if (otp) {
    showLoader();

    setTimeout(() => {
      $.ajax({
        url: `${__appUrl}/api/notifications/verify-otp/${otp}`,
        async: false,
        type: "GET",
        dataType: "text",
        contentType: "application/json;charset=UTF-8",
        success: function (response) {
          if (response.includes("Success")) {
            $('#formio [name="data[submit]"]:visible').removeAttr("disabled");

            $(`.${cleanedKey}-otp-error`).addClass("text-danger");
            $(`.${cleanedKey}-otp-error`).addClass("text-success");
            $(`.${cleanedKey}-otp-submission`).remove();
            $(
              `#formio .formio-component-${cleanedKey} [name="data[${cleanedKey}]"]`
            ).prop("disabled", true);
            $(`.${cleanedKey}-otp-error`).text(
              _translationData[_defaultLanguage.tag].otpVerified
            );
            //setNextBtn();
          } else if (response.includes("Incorrect")) {
            $(`.${cleanedKey}-otp-error`).addClass("text-danger");
            $(`.${cleanedKey}-otp-error`).text(
              _translationData[_defaultLanguage.tag].otpIncorrect
            );
            // $(e)
            //   .parent()
            //   .find(".error-message-otp")
            //   .text(_translationData[_defaultLanguage.tag].otpIncorrect);
          } else if (response.includes("Expired")) {
            $(`.${cleanedKey}-btn`).show();
            $(`.${cleanedKey}-otp-submission`).remove();
            $(`.${cleanedKey}-otp-error`).addClass("text-danger");
            $(`.${cleanedKey}-otp-error`).text(
              _translationData[_defaultLanguage.tag].otpExpired
            );
          }
        },
        error: function (err) {
          const error = getError(err);
          showError(error.messages);
        },
      });

      hideLoader();
    }, 100);
  } else {
    $(e)
      .parent()
      .find(".error-message-otp")
      .text(_translationData[_defaultLanguage.tag].enterOtp);
  }
}

function navigate(e) {
  event.preventDefault();
  _globalForm.triggerChange();
  let isValid = true;
  let isValidRanking = true;
  let isValidCategoryLimit = true;
  if ($(e).prop("id") == "nextBtn") {
    isValid = setNextBtn();
    if (!isValid) {
      return;
    }

    isValid = validateUniquenessNext() && validateUniqueSubmission();
    if (!isValid) {
      const message = _duplicateSubmissionMessage[_defaultLanguage.tag]
        ? _duplicateSubmissionMessage[_defaultLanguage.tag]
        : _translationData[_defaultLanguage.tag].duplicateSubmission;
      showError(message);
      return;
    }
    isValidCategoryLimit = validateCategoryLimit();
    if (!isValidCategoryLimit) {
      showError(_categoryLimitErrors.join(" ,"));
      return;
    }
    isValidRanking = validateRankingOnPageChange();
    if (!isValidRanking) {
      return;
    }
  }

  var nav = $(e).data("nav");
  var preNav = "" + (parseInt($(e).data("nav")) - 1);
  var postNav = "" + (parseInt($(e).data("nav")) + 1);

  if ($(e).prop("id") == "nextBtn") {
    $("#formio .nav-item").each(function () {
      if ($(this).data("customnav") == nav) {
        $(this).addClass("active");
        $(this).find("a").addClass("active");
        $(this).show();
      } else if ($(this).data("customnav") == preNav) {
        $(this).removeClass("active");
        $(this).find("a").removeClass("active");
        $(this).hide();
      }
    });
    $("#formio .tab-pane").each(function () {
      if ($(this).data("customnav") == nav) {
        $(this).addClass("active");
        $(this).show();
      } else if ($(this).data("customnav") == preNav) {
        $(this).removeClass("active");
        $(this).hide();
      }
    });

    $(e).data("nav", postNav);
    $("#prevBtn").data("nav", nav);

    if ($("#formio .nav-item").length == postNav) {
      $(e).removeClass("btn-info");
      $(e).addClass("btn-secondary");
      $(e).attr("disabled", "disabled");
    }
    if (preNav == 0) {
      $("#prevBtn").removeClass("btn-secondary");
      $("#prevBtn").addClass("btn-info");
      $("#prevBtn").removeAttr("disabled");
    }
    //setNextBtn();
    enableOTP();

    if (
      $(
        "#formio .tab-pane.active .formio-component:visible:not(.formio-hidden)"
      ).length == 0
    ) {
      $("#nextBtn").click();
    }

    _currentPage++;

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  } else if ($(e).prop("id") == "prevBtn") {
    $("#formio .nav-item").each(function () {
      if ($(this).data("customnav") == preNav) {
        $(this).addClass("active");
        $(this).find("a").addClass("active");
        $(this).show();
      } else if ($(this).data("customnav") == nav) {
        $(this).removeClass("active");
        $(this).find("a").removeClass("active");
        $(this).hide();
      }
    });
    $("#formio .tab-pane").each(function () {
      if ($(this).data("customnav") == preNav) {
        $(this).addClass("active");
        $(this).show();
      } else if ($(this).data("customnav") == nav) {
        $(this).removeClass("active");
        $(this).hide();
      }
    });
    $(e).data("nav", preNav);
    $("#nextBtn").data("nav", nav);

    if (preNav == 0) {
      $(e).removeClass("btn-info");
      $(e).addClass("btn-secondary");
      $(e).attr("disabled", "disabled");
    }
    if ($("#formio .nav-item").length == postNav) {
      $("#nextBtn").removeClass("btn-secondary");
      $("#nextBtn").addClass("btn-info");
      $("#nextBtn").removeAttr("disabled");
    }
    //setNextBtn();
    if (
      $(
        "#formio .tab-pane.active .formio-component:visible:not(.formio-hidden)"
      ).length == 0
    ) {
      $("#prevBtn").click();
    }

    _currentPage--;
  }

  updateProgressBar();
  setCustomCss();
  addEditGridButtonEvent();
  setSurveyImages();
}

$(document).on("keyup", ".form-control:not('.not-survey')", function () {
  const element = $(this);
  setTimeout(function () {
    const previousFormChangeCopy = _prevFormChange;
    actionsIfFormOnChangeFails(element);
    if ($("#formio .formio-hidden").length != _hiddenCount) {
      if (previousFormChangeCopy != _prevFormChange) {
        showHideLanguageSpecificDetails();
      }

      setCustomCss();
      addLinkedPictures();
      _hiddenCount = $("#formio .formio-hidden").length;
      enableOTP();
      $(".formio-component-editgrid button").each(function () {
        $(this).attr("onclick", "editGridBtnClick(this)");
      });
      linkManipulation();
      setupAudioRecorderForHiddenWhenVisible();
      hideUnhideDepedentLinkedQuestions();
      addLinkedSurveyDataFieldBlurEvent();
      renderQuestionGroups();
    }
    //setNextBtn();
  }, 400);
});

$(document).on("change", ".form-control:not('.not-survey')", function () {
  const element = $(this);
  setTimeout(function () {
    const previousFormChangeCopy = _prevFormChange;
    actionsIfFormOnChangeFails(element);
    if ($("#formio .formio-hidden").length != _hiddenCount) {
      if (previousFormChangeCopy != _prevFormChange) {
        showHideLanguageSpecificDetails();
      }
      setCustomCss();
      addLinkedPictures();
      _hiddenCount = $("#formio .formio-hidden").length;
      enableOTP();
      $(".formio-component-editgrid button").each(function () {
        $(this).attr("onclick", "editGridBtnClick(this)");
      });
      linkManipulation();
      setupAudioRecorderForHiddenWhenVisible();
      hideUnhideDepedentLinkedQuestions();
      addLinkedSurveyDataFieldBlurEvent();
      renderQuestionGroups();
    }
    //setNextBtn();
  }, 400);
});

$(document).on("click", ".form-check-input", function () {
  const element = $(this);
  setTimeout(function () {
    const previousFormChangeCopy = _prevFormChange;
    actionsIfFormOnChangeFails(element);
    if ($("#formio .formio-hidden").length != _hiddenCount) {
      if (previousFormChangeCopy != _prevFormChange) {
        showHideLanguageSpecificDetails();
      }
      setCustomCss();
      addLinkedPictures();
      _hiddenCount = $("#formio .formio-hidden").length;
      $(".formio-component-editgrid button").each(function () {
        $(this).attr("onclick", "editGridBtnClick(this)");
      });
      linkManipulation();
      setupAudioRecorderForHiddenWhenVisible();
      hideUnhideDepedentLinkedQuestions();
      addLinkedSurveyDataFieldBlurEvent();
      renderQuestionGroups();
    }
    //setNextBtn();
  }, 400);
});

const actionsIfFormOnChangeFails = (e) => {
  if (_prevFormChange == _currentFormChange) {
    showHideLanguageSpecificDetails();
    const currentComponent = getValidComponentKeyIfFormOnChangeFails(e);
    if (currentComponent) {
      // hideUnhideLinkedQuestions(
      //   currentComponent.key,
      //   currentComponent.getValue()
      // );
      hideUnhideLinkedQuestionsSimple(currentComponent.key);
      setLinkedDataFields(currentComponent.key, currentComponent.getValue());
      addRanking();
      disableAndClear(currentComponent.key, currentComponent.getValue());
    }

    // if (currentComponent.type == "survey") {
    //   setNextBtn();
    // }
    addNoneOfAbove();
    hideChoiceWhoseLimitHasExceeded();
  } else {
    _prevFormChange++;
  }
};

function getValidComponentKeyIfFormOnChangeFails(e) {
  const potentialKeyList = $(e)
    .closest('[ref="component"]')
    ?.attr("class")
    ?.split(" ")
    ?.filter((x) => x.includes("formio-component-"))
    ?.map((x) => x.replace("formio-component-", ""));
  if (potentialKeyList) {
    for (i = 0; i < potentialKeyList.length; i++) {
      if (_globalForm.getComponent(potentialKeyList[i]) != null) {
        return _globalForm.getComponent(potentialKeyList[i]);
      }
    }
  }
}

function saveDraft() {
  $(`[data-translation="text-draft-submission"]`).text(
    _translationData[_defaultLanguage.tag].draftSubmission
  );
  $(`[data-translation="invalid-feedback-user-name"]`).text(
    _translationData[_defaultLanguage.tag].validUserName
  );
  $(`[data-translation="invalid-feedback-password"]`).text(
    _translationData[_defaultLanguage.tag].validPassword
  );
  $(`[for="userName"]`).text(_translationData[_defaultLanguage.tag].userName);
  $(`[for="password"]`).text(_translationData[_defaultLanguage.tag].password);
  $("#saveorloaddraft").attr("onclick", "saveDraftSubmission()");
  $("#saveorloaddraft").text(_translationData[_defaultLanguage.tag].save);
  $("#closedraft").text(_translationData[_defaultLanguage.tag].close);

  $("#draft-modal").modal("show");
}

function loadDraft() {
  $(`[data-translation="text-draft-submission"]`).text(
    _translationData[_defaultLanguage.tag].draftSubmission
  );
  $(`[data-translation="invalid-feedback-user-name"]`).text(
    _translationData[_defaultLanguage.tag].validUserName
  );
  $(`[data-translation="invalid-feedback-password"]`).text(
    _translationData[_defaultLanguage.tag].validPassword
  );
  $(`[for="userName"]`).text(_translationData[_defaultLanguage.tag].userName);
  $(`[for="password"]`).text(_translationData[_defaultLanguage.tag].password);
  $("#saveorloaddraft").attr("onclick", "loadDraftSubmission()");
  $("#saveorloaddraft").text(_translationData[_defaultLanguage.tag].load);
  $("#closedraft").text(_translationData[_defaultLanguage.tag].close);

  $("#draft-modal").modal("show");
}

function saveDraftSubmission() {
  let data = {
    type: "SurveySubmission",
    details: "",
    userName: $("#userName").val(),
    password: $("#password").val(),
    surveyLink: window.location.href,
  };

  const isValid = validateRequired({
    userName: $("#userName").val(),
    password: $("#password").val(),
  });

  if (!isValid) {
    return;
  }

  let details = getDraftAnswers();

  data.details = JSON.stringify(details, null, 0);

  showLoader(_translationData[_defaultLanguage.tag].savingDraft);

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/submissions/draft-submissions-surveys`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        showSuccess(_translationData[_defaultLanguage.tag].savedDraft);
      },
    });

    hideLoader();
    closeDraft();
  }, 200);
}

function getDraftAnswers() {
  let ignoreTypes = [
    "tabs",
    "button",
    "file",
    "content",
    "columns",
    "panel",
    "table",
  ];
  let details = [];
  let accountedFor = [];

  let editgridMembers = [];

  FormioUtils.eachComponent(
    _builderHidden.instance.schema.components,
    (component) => {
      if (
        component.type != "custom" &&
        ignoreTypes.indexOf(component.type) == -1
      ) {
        if (
          _globalForm.getComponent(component.key) &&
          _globalForm.getComponent(component.key).getValue()
        ) {
          if (component.type == "editgrid") {
            editgridMembers = [
              ...editgridMembers,
              ...component.components.map((x) => x.key),
            ];

            const innerQuestions = component.components.map((x) => ({
              key: x.key,
              label: x.label,
            }));

            details.push({
              key: component.key,
              value: _globalForm.getComponent(component.key).getValue(),
              componentType: component.type,
              primaryQuestion: component.label,
              alias: _alias[component.key],
              innerQuestions,
            });
            accountedFor.push(component.key);
          } else {
            if (!editgridMembers.includes(component.key)) {
              details.push({
                key: component.key,
                value: _globalForm.getComponent(component.key).getValue(),
                componentType: component.type,
                primaryQuestion: component.label,
                alias: _alias[component.key],
              });
              accountedFor.push(component.key);
            }
          }
        }
      } else if (component.type == "custom") {
        let linkedQuestion = _linkedQuestions.filter(
          (q) => q.key == component.key
        )[0];
        let value = getLinkedQuestionAnswer(
          _linkedQuestions.indexOf(linkedQuestion)
        );

        if (value) {
          details.push({
            key: component.key,
            value: value,
            componentType: "custom",
            primaryQuestion: component.label,
            alias: _alias[component.key],
          });
          accountedFor.push(component.key);
        }
      }
    }
  );

  return details;
}

function loadDraftSubmission() {
  let data = {
    userName: $("#userName").val(),
    password: $("#password").val(),
    surveyLink: window.location.href,
  };

  const isValid = validateRequired({
    userName: $("#userName").val(),
    password: $("#password").val(),
  });

  if (!isValid) {
    return;
  }

  showLoader(_translationData[_defaultLanguage.tag].loadingDraft);

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/submissions/draft-submissions-surveys/fetch`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        _draftData = JSON.parse(response.details);
        _surveyAttempt.draftId = response.id;
        setDraftData();
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
      },
    });

    hideLoader();
    closeDraft();
  }, 200);
}

function closeDraft() {
  $("#draftUserName").val("");
  $("#draftPassword").val("");
  $("#draft-modal").modal("hide");
}

function loadWorkflowStatus() {
  $("#workflow-modal").modal("show");
}

function searchWorkflow() {
  event.preventDefault();

  const isValid = validateRequired({
    workflowUniqueKey: $("#workflowUniqueKey").val(),
  });

  if (!isValid) {
    return;
  }

  showLoader();

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/workflows/status-check/${$(
        "#workflowUniqueKey"
      ).val()}`,
      async: false,
      type: "GET",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      success: function (response) {
        showWorkflowStatusCheck(response);
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
      },
    });

    hideLoader();
  }, 200);
}

function forgotWorkflowKey() {
  $(".workflowUniqueKeyDetails").hide();
  $(".workflowStatusCheckDetails").hide();
  $(`[data-translation="btn-search"]`).hide();
  $(".forgotWorkflowKeyDetails label").text(_workflowDetails.contactQuestion);
  let errorMessageText = $(
    `.forgotWorkflowKeyDetails [data-translation="invalid-feedback-workflow-contact-question"]`
  ).text();
  $(
    `.forgotWorkflowKeyDetails [data-translation="invalid-feedback-workflow-contact-question"]`
  ).text(
    errorMessageText.replace(
      "{WORKFLOWCONTACTQUESTION}",
      _workflowDetails.contactQuestion
    )
  );
  $(`[data-translation="btn-forgotworkflowkey"]`).text(
    _translationData[_defaultLanguage.tag].resendUniqueKey
  );
  $(`[data-translation="btn-forgotworkflowkey"]`).attr(
    "onclick",
    "resendWorkflowKey()"
  );
  $(".forgotWorkflowKeyDetails").removeClass("hidden");
}

function resendWorkflowKey() {
  event.preventDefault();

  const isValid = validateRequired({
    workflowContactQuestion: $("#workflowContactQuestion").val(),
  });

  if (!isValid) {
    return;
  }

  showLoader();

  const data = {
    contactQuestion: _workflowDetails.contactQuestion,
    contactQuestionAnswer: $("#workflowContactQuestion").val(),
    contactQuestionType: _workflowDetails.contactType,
    surveyId: _surveyId,
  };

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/workflows/resend-unique-key`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        showWorkflowStatusCheck(response);
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
      },
    });

    hideLoader();
  }, 200);
}

function showWorkflowStatusCheck(workflowStatusCheck) {
  let isReSubmitable = false;
  const workflowStatus = JSON.parse(workflowStatusCheck.workflowStatus);
  let workflowStatusHtml = "";

  for (key in workflowStatus) {
    if (workflowStatus[key] !== "completed") {
      isReSubmitable = true;
    }
    const status =
      workflowStatus[key] === "completed"
        ? _translationData[_defaultLanguage.tag].accepted
        : workflowStatus[key] === "rejected"
        ? _translationData[_defaultLanguage.tag].rejected
        : _translationData[_defaultLanguage.tag].inprogress;
    workflowStatusHtml += `
      <div class="row d-flex justify-content-between ps-3 pe-3">
        <div>
          ${key}
        </div>
        <div>
          ${status}
        </div>
      </div>
    `;
  }

  isReSubmitable =
    isReSubmitable && workflowStatusCheck.isOpenedForReSubmission;

  const workflowComments = workflowStatusCheck.workflowComments?.map((x) => {
    return `
      <div class="col-lg-12 comment">
        <div class="comment-title">
          ${formatDateTime(x.createdDate)}
        </div>
        <div class="comment-content">
          ${x.comment}
        </div>
      </div>
    `;
  });

  const editSubmission = isReSubmitable
    ? `
    <div class="pt-2">
      <button class="btn btn-sm btn-primary" onclick="loadWorkflowSubmission(${
        workflowStatusCheck.attemptId
      },'${$("#workflowUniqueKey").val()}')">${
        _translationData[_defaultLanguage.tag].load
      }</button>
    </div>
  `
    : "";

  $("#workflow-modal #workflow-body .workflowStatusCheckDetails").html(`
    <div class="workflowstatuscheck border border-1 p-2">
      ${workflowComments.join("")}
    </div>
    <div class="workflowstatuscheck border border-1 p-2">
      ${workflowStatusHtml}
    </div>
    ${editSubmission}
  `);
}

function closeWorkflow() {
  $(".workflowUniqueKeyDetails").show();
  $(".workflowStatusCheckDetails").show();
  $(`[data-translation="btn-search"]`).show();
  $("#workflow-modal .workflow-body .workflowstatuscheck").remove();

  $(".forgotWorkflowKeyDetails label").text("");
  let errorMessageText = $(
    `.forgotWorkflowKeyDetails [data-translation="invalid-feedback-workflow-contact-question"]`
  ).text();
  $(
    `.forgotWorkflowKeyDetails [data-translation="invalid-feedback-workflow-contact-question"]`
  ).text(
    errorMessageText.replace(
      _workflowDetails.contactQuestion,
      "{WORKFLOWCONTACTQUESTION}"
    )
  );
  $(`[data-translation="btn-forgotworkflowkey"]`).text(
    _translationData[_defaultLanguage.tag].forgotUniqueKey
  );
  $(`[data-translation="btn-forgotworkflowkey"]`).attr(
    "onclick",
    "forgotWorkflowKey()"
  );
  $(".forgotWorkflowKeyDetails").addClass("hidden");

  $("#workflow-modal").modal("hide");
}

function loadWorkflowSubmission(attemptId, workflowUniqueKey) {
  var data = {
    attemptId,
    workflowUniqueKey,
  };

  showLoader();

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/workflows/resubmission`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        _workflowUniqueKey = workflowUniqueKey;
        setWorkflowSurveyResponseForReSubmission(response);
      },
      error: function (err) {
        const error = getError(err);
        showError(error.messages);
      },
    });

    hideLoader();
    closeWorkflow();
  }, 200);
}

$(document).on("change", ".none-of-above", function () {
  const classes = $(this).attr("class").split(" ");
  const keyClass = classes.filter((x) => x.includes("-none-of-above"))[0]; //classes[classes.length - 1];
  const key = keyClass.split("-none-of-above")[0];
  if ($(this).prop("checked")) {
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.none-of-above)")
      .attr("disabled", true);
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.none-of-above)")
      .prop("checked", false);
    setTimeout(() => {
      const val = _globalForm.getComponent(key).getValue();
      _globalForm.getComponent(key).setValue(val);
    }, 300);
    return;
  } else {
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.none-of-above)")
      .removeAttr("disabled");
  }
});

$(document).on("change", ".all-of-above", function () {
  const classes = $(this).attr("class").split(" ");
  const keyClass = classes.filter((x) => x.includes("-all-of-above"))[0];
  const key = keyClass.split("-all-of-above")[0];
  if ($(this).prop("checked")) {
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.all-of-above)")
      .attr("disabled", true);
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.all-of-above)")
      .prop("checked", true);
    setTimeout(() => {
      const val = _globalForm.getComponent(key).getValue();
      _globalForm.getComponent(key).setValue(val);
    }, 300);
    return;
  } else {
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.all-of-above)")
      .removeAttr("disabled");
    $(this)
      .closest(".form-radio")
      .find(".form-check input:not(.all-of-above)")
      .prop("checked", false);
  }
});

function loginToViewSurvey() {
  const data = {
    surveyId: _surveyId,
    userId: $("#login-modal #userId").val(),
    password: $("#login-modal #password").val(),
  };

  const isValid = validateLoginForm(data);
  if (!isValid) {
    return;
  }

  showLoader(_translationData[_defaultLanguage.tag].loggingIn);

  setTimeout(() => {
    $.ajax({
      url: `${__appUrl}/api/loginsurvey/login`,
      async: false,
      type: "POST",
      dataType: "json",
      contentType: "application/json;charset=UTF-8",
      data: JSON.stringify(data),
      success: function (response) {
        _token = response.token;
        _attemptId = response.attemptId;
        initializeSurveyDetails(response.survey);
        $("#login-modal").modal("hide");

        setTimeout(() => {
          loadUserAnswers(response.answers);
        }, 1000);
      },
      error: function (err) {
        const error = getError(err);
        if (error.type == "BusinessLogicValidation") {
          _userLanguage = error.messages == "Arabic" ? "ar" : "en";
          showError(_translationData[_userLanguage].alreaySubmitted);
        } else {
          showError(_translationData[_defaultLanguage.tag].loginFailed);
        }
      },
    });

    hideLoader();
  }, 200);
}

// #endregion
